


import React, { useState, useEffect, useRef } from 'react';
import "./OrderPage.css";
import { useAuth } from '../auth/Auth';
import axios from 'axios';



function OrderPage() {
  const [currency, setCurrency] = useState('EUR'); 
  const [exchangeRate, setExchangeRate] = useState(51.62); 
  const [orderDrafts, setOrderDrafts] = useState([]);
const [showOrderDraftsList, setShowOrderDraftsList] = useState(false);
const [loadingOrderDrafts, setLoadingOrderDrafts] = useState(false);
const [savingOrderDraft, setSavingOrderDraft] = useState(false);

  const [loadingRate, setLoadingRate] = useState(false); 
  const { user } = useAuth();
  const [systems, setSystems] = useState([]);
  const [categories, setCategories] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [orders, setOrders] = useState([]);
  const [showOrdersList, setShowOrdersList] = useState(false);
  const [userDiscount, setUserDiscount] = useState(0);
  const [dealerName, setDealerName] = useState('');
  const [contractorName, setContractorName] = useState('');
  const [systemParams, setSystemParams] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [nextOrderNumber, setNextOrderNumber] = useState(1);
  const [authError, setAuthError] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [userToken, setUserToken] = useState('');
  const [colorSearch, setColorSearch] = useState('');
  const [filteredColors, setFilteredColors] = useState([]);
  const [showColorDropdown, setShowColorDropdown] = useState(false);
  const colorRef = useRef(null);
  
  
  const [availableFabrics, setAvailableFabrics] = useState([]);
  const [availableQualities, setAvailableQualities] = useState(['z', 'a', 'b', 'c', 'd', 'e', 'f']);
  const [systemType, setSystemType] = useState('');
  const [availableColors, setAvailableColors] = useState([]);
  const [priceType, setPriceType] = useState('Стандартний прайс');
  const [editingItemIndex, setEditingItemIndex] = useState(null);
  const [showControlFields, setShowControlFields] = useState(false);
  const [showPriceResult, setShowPriceResult] = useState(false);
  const [rangeErrors, setRangeErrors] = useState({ width: false, height: false });
  const [showBoxHeight, setShowBoxHeight] = useState(false);
  const [showMountingType, setShowMountingType] = useState(false);
  const [draftItems, setDraftItems] = useState([]);
  const [loadingDrafts, setLoadingDrafts] = useState(false);
  const [requiredFields, setRequiredFields] = useState({ boxHeight: false, mountingType: false });
  
  const [showFabricModal, setShowFabricModal] = useState(false);
  const [fabricsWithImages, setFabricsWithImages] = useState([]);
  const [filteredFabrics, setFilteredFabrics] = useState([]);
  const [fabricSearch, setFabricSearch] = useState('');
  const [selectedFabric, setSelectedFabric] = useState(null);
  const [loadingFabrics, setLoadingFabrics] = useState(false);
  
  const [systemSearch, setSystemSearch] = useState('');
  const [filteredSystems, setFilteredSystems] = useState([]);
  const [showSystemDropdown, setShowSystemDropdown] = useState(false);
  const systemSearchRef = useRef(null);
  const systemInputRef = useRef(null);
  
  const mountingTypeRef = useRef(null);
  const controlSideRef = useRef(null);
  const [showMountingDropdown, setShowMountingDropdown] = useState(false);
  const [showControlSideDropdown, setShowControlSideDropdown] = useState(false);
  const [mountingSearch, setMountingSearch] = useState('');
  const [controlSideSearch, setControlSideSearch] = useState('');
  
  const [systemTypeSearch, setSystemTypeSearch] = useState('');
  const [filteredSystemTypes, setFilteredSystemTypes] = useState([]);
  const [showSystemTypeDropdown, setShowSystemTypeDropdown] = useState(false);
  const systemTypeRef = useRef(null);

  const userId = user?.user_id?.toString() || localStorage.getItem('userId')?.toString() || '271';

  const hasAutoSavedRef = useRef(false);

const isProcessingRef = useRef(false);
const [rateMode, setRateMode] = useState('manual'); 


useEffect(() => {
  console.log('[useEffect] Перевірка умов для автоматичного перенесення...');
  
  
  if (hasAutoSavedRef.current) {
    console.log('Вже виконано, пропускаємо');
    return;
  }
  
  
  if (!userId) {
    console.log('Немає userId');
    return;
  }
  
  
  if (loading) {
    console.log('Ще завантажується, чекаємо...');
    return;
  }
  
  
  if (isProcessingRef.current) {
    console.log('Вже в процесі виконання, пропускаємо');
    return;
  }
  
  console.log('Умови виконано, запускаємо перенесення...');
  isProcessingRef.current = true;
  
  const autoSaveSavedPositionsToDrafts = async () => {
    try {
      console.log('Перевірка збережених позицій...');
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/get-order-positions/${userId}`);
      console.log('Відповідь API:', response.data);
      
      if (response.data.success && 
          response.data.data && 
          response.data.data.items && 
          response.data.data.items.length > 0) {
        
        const savedItems = response.data.data.items;
        console.log(`Знайдено ${savedItems.length} збережених позицій`);
        
        
        const draftsResponse = await axios.get(`https://test2.planfix-to-syrve.com/api/user-drafts/${userId}`);
        const existingDrafts = draftsResponse.data.success ? draftsResponse.data.data : [];
        console.log(`Поточних чернеток: ${existingDrafts.length}`);
        
        
        const newItems = savedItems.filter(item => 
          !existingDrafts.some(draft => 
            draft.systemName === item.systemName && 
            draft.fabricCode === item.fabricCode && 
            draft.width === item.width && 
            draft.height === item.height
          )
        );
        
        if (newItems.length === 0) {
          console.log('Всі збережені позиції вже є в чернетках');
          await clearSavedPositions();
          hasAutoSavedRef.current = true;
          isProcessingRef.current = false;
          return;
        }
        
        console.log(`Знайдено ${newItems.length} нових позицій для збереження в чернетки`);
        
        for (const item of newItems) {
          const draftItem = {
            id: `draft_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            systemType: item.systemType || '',
            systemName: item.systemName || '',
            fabricCode: item.fabricCode || '',
            fabricQuality: item.fabricQuality || '',
            fabricColor: item.fabricColor || '',
            width: item.width || '',
            height: item.height || '',
            boxHeight: item.boxHeight || '',
            mountingType: item.mountingType || '',
            controlSide: item.controlSide || '',
            controlLength: item.controlLength || '',
            quantity: item.quantity || 1,
            price: item.price || 0,
            sum: item.sum || 0,
            itemNotes: item.itemNotes || '',
            add: item.add || [],
            accessoriesItems: item.accessoriesItems || [],
            draft: true,
            createdAt: new Date().toISOString()
          };
          
          try {
            await axios.post(`https://test2.planfix-to-syrve.com/api/save-draft`, { 
              userId, 
              draft: draftItem 
            });
            console.log('Чернетку збережено:', draftItem.systemName);
          } catch (saveError) {
            console.error('Помилка збереження чернетки:', saveError);
          }
        }
        
        await clearSavedPositions();
        await fetchDrafts();
        hasAutoSavedRef.current = true;
        isProcessingRef.current = false;
        console.log('Всі збережені позиції перенесено в чернетки');
      } else {
        console.log('Немає збережених позицій');
        hasAutoSavedRef.current = true;
        isProcessingRef.current = false;
      }
    } catch (error) {
      console.error('Помилка обробки збережених позицій:', error);
      hasAutoSavedRef.current = true;
      isProcessingRef.current = false;
    }
  };
  
  autoSaveSavedPositionsToDrafts();
  
}, [userId, loading]); 

useEffect(() => {
  fetchExchangeRate();
}, []);


useEffect(() => {
  if (rateMode !== 'auto') return;


  fetchExchangeRate();


  const interval = setInterval(fetchExchangeRate, 30 * 60 * 1000);
  return () => clearInterval(interval);
}, [rateMode]);


const manualUpdateRate = async () => {
  setLoadingRate(true);
  try {
    await fetchExchangeRate();
    alert(`Курс оновлено: 1€ = ${exchangeRate.toFixed(2)} ₴`);
  } catch (error) {
    console.error('Помилка оновлення курсу:', error);
    alert('Помилка при оновленні курсу');
  } finally {
    setLoadingRate(false);
  }
};

useEffect(() => {
  if (userId) {
    fetchDrafts();
  }
}, [userId]);





const convertPrice = (priceInEuro) => {
 
  if (priceInEuro === undefined || priceInEuro === null) {
    return 0;
  }
  

  let price;
  if (typeof priceInEuro === 'string') {
    price = parseFloat(priceInEuro.replace(',', '.'));
  } else {
    price = parseFloat(priceInEuro);
  }
  

  if (isNaN(price)) {
    return 0;
  }
  

  if (currency === 'UAH') {
    return price * exchangeRate;
  }
  return price;
};

const copyItem = (index) => {
  const itemToCopy = currentOrder.items[index];
  if (!itemToCopy) return;
  
  console.log('=== КОПІЮВАННЯ ПОЗИЦІЇ ===');
  console.log('Дані позиції для копіювання:', itemToCopy);
  
  let foundSystemType = itemToCopy.systemType || '';
  if (!foundSystemType && itemToCopy.systemName && categories) {
    const foundCategory = Object.entries(categories).find(([cat, sysList]) => sysList.includes(itemToCopy.systemName));
    if (foundCategory) foundSystemType = foundCategory[0];
  }
  
  
  const safeBasePrice = itemToCopy.basePrice || itemToCopy.price || 0;
  const safeQuantity = itemToCopy.quantity || 1;
  
  
  const copiedAccessories = [];
  
  
  if (itemToCopy.add && Array.isArray(itemToCopy.add) && itemToCopy.add.length > 0) {
    console.log('Копіювання додатків з item.add:', itemToCopy.add);
    for (let idx = 0; idx < itemToCopy.add.length; idx++) {
      const acc = itemToCopy.add[idx];
      const price = parseFloat(acc.basePriceadd) || parseFloat(acc.price) || 0;
      const qty = parseInt(acc.amountadd) || parseInt(acc.quantity) || 1;
      copiedAccessories.push({
        id: Date.now() + idx,
        name: acc.name_add || acc.name,
        quantity: qty,
        price: price,
        sum: price * qty
      });
    }
  }
  
  
  if (copiedAccessories.length === 0 && itemToCopy.accessoriesItems && Array.isArray(itemToCopy.accessoriesItems) && itemToCopy.accessoriesItems.length > 0) {
    console.log('Копіювання додатків з item.accessoriesItems:', itemToCopy.accessoriesItems);
    for (let idx = 0; idx < itemToCopy.accessoriesItems.length; idx++) {
      const acc = itemToCopy.accessoriesItems[idx];
      const price = parseFloat(acc.price) || parseFloat(acc.basePriceadd) || 0;
      const qty = parseInt(acc.quantity) || parseInt(acc.amountadd) || 1;
      copiedAccessories.push({
        id: Date.now() + idx,
        name: acc.name || acc.name_add,
        quantity: qty,
        price: price,
        sum: price * qty
      });
    }
  }
  
  console.log('Скопійовано додатків:', copiedAccessories.length);
  
  
  setCurrentItem({
    number: currentOrder.items.length + 1,
    systemType: foundSystemType || '',
    systemName: itemToCopy.systemName || '',
    fabricCode: itemToCopy.fabricCode || '',
    fabricQuality: itemToCopy.fabricQuality || '',
    fabricColor: itemToCopy.fabricColor || '',
    width: itemToCopy.width || '',
    height: itemToCopy.height || '',
    boxHeight: itemToCopy.boxHeight || '',
    mountingType: itemToCopy.mountingType || '',
    controlSide: itemToCopy.controlSide === '-' ? '' : (itemToCopy.controlSide || ''),
    controlLength: itemToCopy.controlLength || '',
    quantity: safeQuantity,
    price: safeBasePrice,
    sum: safeBasePrice * safeQuantity,
    itemNotes: itemToCopy.itemNotes || ''
  });
  
  
  setAccessoriesItems([]);
  if (copiedAccessories.length > 0) {
    setTimeout(() => {
      setAccessoriesItems(copiedAccessories);
      setShowAccessoriesPanel(true);
    }, 100);
  } else {
    setShowAccessoriesPanel(false);
  }
  
  
  setSystemSearch(itemToCopy.systemName || '');
  setSystemTypeSearch(foundSystemType || '');
  const mountingLabel = mountingTypes2.find(m => m.value === itemToCopy.mountingType)?.label || '';
  setMountingSearch(mountingLabel);
  const controlSideLabel = controlSideOptions.find(c => c.value === itemToCopy.controlSide)?.label || '';
  setControlSideSearch(controlSideLabel);
  setColorSearch(itemToCopy.fabricColor || '');
  
  
  setEditingItemIndex(null);
  
  
  if (itemToCopy.priceCalculation) {
    const accessoriesTotal = copiedAccessories.reduce((sum, acc) => sum + (acc.price * acc.quantity), 0);
    setPriceCalculation({
      loading: false,
      result: {
        ...itemToCopy.priceCalculation,
        systemBasePrice: itemToCopy.priceCalculation.systemBasePrice || safeBasePrice,
        systemFinalPrice: itemToCopy.priceCalculation.systemFinalPrice || safeBasePrice,
        basePrice: itemToCopy.priceCalculation.basePrice || safeBasePrice,
        finalPrice: itemToCopy.priceCalculation.finalPrice || safeBasePrice,
        accessoriesTotal: accessoriesTotal,
        totalBeforeDiscount: (safeBasePrice * safeQuantity) + accessoriesTotal,
        totalAfterDiscount: (safeBasePrice * safeQuantity) + accessoriesTotal
      },
      error: null,
      warnings: []
    });
    setShowPriceResult(true);
  } else {
    setShowPriceResult(false);
  }
  
  
  const formSection = document.querySelector('.form-section');
  if (formSection) {
    formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  
  
  console.log('Позицію скопійовано в форму');
};


const getCurrencySymbol = () => {
  return currency === 'UAH' ? '₴' : '€';
};

const fetchExchangeRate = async () => {
  setLoadingRate(true);
  try {
    const response = await axios.get('https://test2.planfix-to-syrve.com/api/exchange-rate');
    if (response.data.success) {
      setExchangeRate(response.data.rate);
      setRateMode(response.data.mode || 'manual');
      console.log('Курс отримано:', response.data.rate, 'режим:', response.data.mode);
    }
  } catch (error) {
    console.error('Помилка отримання курсу:', error);
    setExchangeRate(51.62);
  } finally {
    setLoadingRate(false);
  }
};



  const mountingTypes2 = [
    { value: 'wall', label: 'На стіну' },
    { value: 'ceiling', label: 'На стелю' },
    { value: 'opening', label: 'У відкоси' }
  ];

  const controlSideOptions = [
    { value: 'left', label: 'Ліва' },
    { value: 'right', label: 'Права' }
  ];

  const [currentOrder, setCurrentOrder] = useState({
    id: null,
    dealer: '',
    orderNumber: '',
    date: new Date().toISOString().split('T')[0],
    items: [],
    notes: '',
    status: 'draft'
  });

  const [currentItem, setCurrentItem] = useState({
    number: 1,
    systemType: '',
    systemName: '',
    fabricCode: '',
    fabricQuality: '',
    fabricColor: '',
    width: '',
    height: '',
    boxHeight: '',
    mountingType: '',
    controlSide: '',
    controlLength: '',
    quantity: 1,
    price: 0,
    sum: 0,
    itemNotes: ''
  });

  const [priceCalculation, setPriceCalculation] = useState({
    loading: false,
    result: null,
    error: null,
    warnings: []
  });

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    message: '',
    onConfirm: null,
    onCancel: null,
    itemIndex: null
  });
  
  const [availableAccessories, setAvailableAccessories] = useState([]);
  const [showAccessoriesPanel, setShowAccessoriesPanel] = useState(false);
  const [accessoriesItems, setAccessoriesItems] = useState([]);
  const [loadingAccessories, setLoadingAccessories] = useState(false);
  const [newAccessory, setNewAccessory] = useState({
    name: '',
    quantity: 1,
    price: 0,
    sum: 0
  });
  const [accessorySearch, setAccessorySearch] = useState('');
  const [filteredAccessories, setFilteredAccessories] = useState([]);
  const [showAccessoryDropdown, setShowAccessoryDropdown] = useState(false);
  const accessoryRef = useRef(null);

  const fetchAvailableAccessories = async () => {
    if (!currentItem.systemName) {
      setAvailableAccessories([]);
      setAccessoriesItems([]);
      setShowAccessoriesPanel(false);
      return;
    }
    
    setLoadingAccessories(true);
    try {
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/available-accessories`, {
        params: {
          systemName: currentItem.systemName,
          colorName: currentItem.fabricColor
        }
      });
      
      if (response.data.success && response.data.data.length > 0) {
        setAvailableAccessories(response.data.data);
      } else {
        setAvailableAccessories([]);
        
        if (accessoriesItems.length > 0) {
          setAccessoriesItems([]);
        }
        setShowAccessoriesPanel(false);
      }
    } catch (error) {
      console.error('Помилка завантаження додаткових комплектуючих:', error);
      setAvailableAccessories([]);
      setAccessoriesItems([]);
      setShowAccessoriesPanel(false);
    } finally {
      setLoadingAccessories(false);
    }
  };

const fetchAccessoryPrice = async (accessoryName) => {
  try {
    const response = await axios.get(`https://test2.planfix-to-syrve.com/api/accessory-price`, {
      params: {
        accessoryName: accessoryName,
        colorName: currentItem.fabricColor
      }
    });
    
    if (response.data.success) {
      return response.data.data.price;
    }
    return 0;
  } catch (error) {
    console.error('Помилка отримання ціни додатку:', error);
    return 0;
  }
};


const addAccessoryRow = () => {
  if (!newAccessory.name || newAccessory.quantity < 1) {
    alert('Виберіть додаток та вкажіть кількість');
    return;
  }
  
  
  let quantityToAdd = parseInt(newAccessory.quantity);
  if (isNaN(quantityToAdd) || quantityToAdd < 1) {
    quantityToAdd = 1;
  }
  
  console.log('Додаємо додаток:', newAccessory.name, 'кількість:', quantityToAdd);
  
  
  const existingIndex = accessoriesItems.findIndex(
    item => item.name === newAccessory.name
  );
  
  if (existingIndex !== -1) {
    
    const updatedItems = [...accessoriesItems];
    const existingItem = updatedItems[existingIndex];
    const newQuantity = existingItem.quantity + quantityToAdd;
    
    updatedItems[existingIndex] = {
      ...existingItem,
      quantity: newQuantity,
      sum: existingItem.price * newQuantity
    };
    
    console.log('Оновлюємо існуючий додаток:', {
      name: newAccessory.name,
      oldQuantity: existingItem.quantity,
      addQuantity: quantityToAdd,
      newQuantity: newQuantity,
      newSum: existingItem.price * newQuantity
    });
    
    setAccessoriesItems(updatedItems);
  } else {
    
    const newItem = {
      id: Date.now(),
      name: newAccessory.name,
      quantity: quantityToAdd,
      price: newAccessory.price,
      sum: newAccessory.price * quantityToAdd
    };
    
    console.log('Додаємо новий додаток:', newItem);
    setAccessoriesItems([...accessoriesItems, newItem]);
  }
  
  
  setNewAccessory({
    name: '',
    quantity: 1,
    price: 0,
    sum: 0
  });
  setAccessorySearch('');
  setShowAccessoryDropdown(false);
  
  
  setTimeout(() => {
    if (currentItem.systemName && currentItem.fabricCode && 
        currentItem.fabricColor && currentItem.fabricQuality && 
        currentItem.width && currentItem.height) {
      calculatePrice();
    }
  }, 100);
};

const removeAccessoryRow = (id) => {
  setAccessoriesItems(accessoriesItems.filter(item => item.id !== id));
};

const handleAccessorySelect = async (accessory) => {
  
  let price = accessory.price;
  
  
  if (price === 0) {
    price = await fetchAccessoryPrice(accessory.name);
  }
  
  
  const existingItem = accessoriesItems.find(item => item.name === accessory.name);
  
  
  let suggestedQuantity = 1;
  if (existingItem) {
    suggestedQuantity = existingItem.quantity + 1;
  }
  
  console.log('Вибрано додаток:', accessory.name, 'ціна:', price, 'пропонована кількість:', suggestedQuantity);
  
  
  setNewAccessory({
    name: accessory.name,
    quantity: suggestedQuantity,
    price: price,
    sum: price * suggestedQuantity
  });
  
  
  setAccessorySearch(accessory.name);
  
  
  setShowAccessoryDropdown(false);
};

const mergeAllDuplicateAccessories = () => {
  console.log('Обєднуємо дублікати додатків...');
  console.log('Поточний список:', accessoriesItems);
  
  const mergedMap = new Map();
  
  for (const acc of accessoriesItems) {
    if (mergedMap.has(acc.name)) {
      const existing = mergedMap.get(acc.name);
      const newQuantity = existing.quantity + acc.quantity;
      mergedMap.set(acc.name, {
        ...existing,
        quantity: newQuantity,
        sum: existing.price * newQuantity
      });
      console.log(`Об'єднуємо ${acc.name}: ${existing.quantity} + ${acc.quantity} = ${newQuantity}`);
    } else {
      mergedMap.set(acc.name, { ...acc });
    }
  }
  
  const mergedItems = Array.from(mergedMap.values()).map((item, idx) => ({
    ...item,
    id: Date.now() + idx
  }));
  
  console.log('Результат об/єднання:', mergedItems);
  
  if (mergedItems.length !== accessoriesItems.length) {
    setAccessoriesItems(mergedItems);
    
    setTimeout(() => {
      if (currentItem.systemName && currentItem.fabricCode && 
          currentItem.fabricColor && currentItem.fabricQuality && 
          currentItem.width && currentItem.height) {
        calculatePrice();
      }
    }, 100);
  }
};

useEffect(() => {
  const mergeDuplicates = () => {
    const mergedMap = new Map();
    
    for (const acc of accessoriesItems) {
      if (mergedMap.has(acc.name)) {
        const existing = mergedMap.get(acc.name);
        const newQuantity = existing.quantity + acc.quantity;
        mergedMap.set(acc.name, {
          ...existing,
          quantity: newQuantity,
          sum: existing.price * newQuantity
        });
      } else {
        mergedMap.set(acc.name, { ...acc });
      }
    }
    
    const mergedItems = Array.from(mergedMap.values()).map((item, idx) => ({
      ...item,
      id: Date.now() + idx
    }));
    
    
    if (mergedItems.length !== accessoriesItems.length && accessoriesItems.length > 0) {
      console.log('Виявлено дублікати, виконуємо обєднання...');
      setAccessoriesItems(mergedItems);
    }
  };
  
  mergeDuplicates();
}, [accessoriesItems]);

useEffect(() => {
  if (currentOrder.items.length > 0) {
    const updatedItems = currentOrder.items.map(item => {
      
      if (!item.finalPrice && item.priceCalculation?.finalPrice) {
        return {
          ...item,
          finalPrice: item.priceCalculation.finalPrice,
          finalSum: item.priceCalculation.totalAfterDiscount
        };
      }
      return item;
    });
    
    if (JSON.stringify(updatedItems) !== JSON.stringify(currentOrder.items)) {
      setCurrentOrder(prev => ({ ...prev, items: updatedItems }));
    }
  }
}, [currentOrder.orderNumber]);
const updateAccessoryQuantity = (id, quantity) => {
  const updatedItems = accessoriesItems.map(item => {
    if (item.id === id) {
      const newQuantity = parseInt(quantity) || 1;
      return {
        ...item,
        quantity: newQuantity,
        sum: item.price * newQuantity
      };
    }
    return item;
  });
  setAccessoriesItems(updatedItems);
  
  
  setTimeout(() => {
    if (currentItem.systemName && currentItem.fabricCode && 
        currentItem.fabricColor && currentItem.fabricQuality && 
        currentItem.width && currentItem.height) {
      calculatePrice();
    }
  }, 100);
};

const updateAccessoryPrice = (id, price) => {
  const updatedItems = accessoriesItems.map(item => {
    if (item.id === id) {
      const newPrice = parseFloat(price) || 0;
      return {
        ...item,
        price: newPrice,
        sum: newPrice * item.quantity
      };
    }
    return item;
  });
  setAccessoriesItems(updatedItems);
};

useEffect(() => {
  
  if (accessoriesItems.length > 0) {
    setAccessoriesItems([]);
  }
  
  setShowAccessoriesPanel(false);
  
  setNewAccessory({
    name: '',
    quantity: 1,
    price: 0,
    sum: 0,
    quantityError: false
  });
  setAccessorySearch('');
  setFilteredAccessories([]);
  setShowAccessoryDropdown(false);
}, [currentItem.systemName]);

useEffect(() => {
  if (currentItem.systemName) {
    fetchAvailableAccessories();
  } else {
    setAvailableAccessories([]);
    setAccessoriesItems([]);
    setShowAccessoriesPanel(false);
  }
}, [currentItem.systemName, currentItem.fabricColor]);



useEffect(() => {
  
  
  if (accessorySearch.trim()) {
    const filtered = availableAccessories.filter(acc =>
      acc.name.toLowerCase().includes(accessorySearch.toLowerCase())
    );
    setFilteredAccessories(filtered);
    
  } else {
    setFilteredAccessories([]);
    
  }
}, [accessorySearch, availableAccessories]);


useEffect(() => {
  const handleClickOutside = (event) => {
    if (accessoryRef.current && !accessoryRef.current.contains(event.target)) {
      setShowAccessoryDropdown(false);
    }
  };
  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);

  
  
  
  const savePositionsToFile = async (items, orderNum, dealer, notesText, statusText) => {
    if (!userId) return;
    
    try {
      await axios.post(`https://test2.planfix-to-syrve.com/api/update-order-positions/${userId}`, {
        items: items,
        orderNumber: orderNum,
        dealer: dealer,
        notes: notesText,
        status: statusText
      });
      console.log('Позиції збережено успішно');
    } catch (error) {
      console.error('Помилка збереження позицій:', error);
    }
  };

  const recalculateSavedItemPrice = async (item) => {
    try {
      if (!item.systemName || !item.fabricCode || !item.fabricColor || !item.fabricQuality || !item.width || !item.height) {
        console.warn('Недостатньо даних для перерахунку позиції:', item);
        return item;
      }
  
      const heightInMeters = parseFloat(item.height) / 100;
      let roundedWidth = parseFloat(item.width);
      let roundedHeight = parseFloat(item.height);
      
      let systemParamsData = null;
      try {
        const paramsResponse = await axios.get(`https://test2.planfix-to-syrve.com/api/system-params/${encodeURIComponent(item.systemName)}`);
        if (paramsResponse.data.success) {
          systemParamsData = paramsResponse.data.data;
          
          if (systemParamsData.widthRange?.available) {
            const sortedWidths = [...systemParamsData.widthRange.available].sort((a, b) => a - b);
            for (let i = 0; i < sortedWidths.length; i++) {
              if (sortedWidths[i] >= roundedWidth - 0.01) {
                roundedWidth = sortedWidths[i];
                break;
              }
            }
          }
          
          if (systemParamsData.availableHeights) {
            const sortedHeights = [...systemParamsData.availableHeights].sort((a, b) => a - b);
            for (let i = 0; i < sortedHeights.length; i++) {
              if (sortedHeights[i] >= roundedHeight - 0.01) {
                roundedHeight = sortedHeights[i];
                break;
              }
            }
          }
        }
      } catch (error) {
        console.error('Помилка отримання параметрів системи:', error);
      }
      
      
      const response = await axios.post(`https://test2.planfix-to-syrve.com/api/calculate-price`, {
        systemName: item.systemName,
        height: roundedHeight / 100,
        width: parseInt(roundedWidth),
        quality: item.fabricQuality,
        fabricCode: item.fabricCode,  
        color: item.fabricColor,
        userId: userId
      });
  
      const data = response.data;
  
      if (data.success) {
        return {
          ...item,
          price: data.data.basePrice,
          sum: data.data.finalPrice * (item.quantity || 1),
          priceCalculation: data.data,
          roundedWidth: roundedWidth,
          roundedHeight: roundedHeight,
          recalculatedAt: new Date().toISOString()
        };
      }
      return item;
    } catch (error) {
      console.error('Помилка перерахунку ціни збереженої позиції:', error);
      return item;
    }
  };


const [isRestoring, setIsRestoring] = useState(false);





  


    



      







      







          


















            










            


            









            
           
            




















const loadSavedPositions = async () => {
  if (!userId) return;
  if (isRestoring) return;
  
  try {
    const response = await axios.get(`https://test2.planfix-to-syrve.com/api/get-order-positions/${userId}`);
    
    
    if (response.data.success && 
        response.data.data && 
        response.data.data.items && 
        response.data.data.items.length > 0 &&
        
        response.data.data.items.some(item => item.systemName || item.fabricCode)) {
      
      const savedOrder = response.data.data;
      const oldItemsCount = savedOrder.items.length;
      
      
      const isNewEmptyOrder = currentOrder.items.length === 0 && 
                               currentOrder.orderNumber === 'ЗАМ-001' &&
                               !currentOrder.notes;
      
      if (isNewEmptyOrder) {
        
        console.log('Нове порожнє замовлення, пропонуємо відновити...');
      } else if (currentOrder.items.length > 0) {
        
        console.log('В поточному замовленні вже є позиції, пропуск відновлення');
        await clearSavedPositions();
        return;
      }
      
      showConfirm(
        `Знайдено збережені позиції замовлення\n` +
        `Кількість позицій: ${oldItemsCount}\n\n` +
        `Бажаєте відновити їх?`,
        async () => {
          setIsRestoring(true);
          setLoading(true);
          
          try {
            const recalculatedItems = [];
            for (const item of savedOrder.items) {
              if (!item.basePrice && item.price) item.basePrice = item.price;
              if (!item.finalPrice && item.price) item.finalPrice = item.price;
              if (!item.accessoriesTotal) item.accessoriesTotal = 0;
              const recalculatedItem = await recalculateSavedItemPrice(item);
              recalculatedItems.push(recalculatedItem);
            }
            
            setCurrentOrder({
              id: null,
              dealer: savedOrder.dealer || dealerDisplayName,
              orderNumber: savedOrder.orderNumber || currentOrder.orderNumber,
              date: new Date().toISOString().split('T')[0],
              items: recalculatedItems,
              notes: savedOrder.notes || '',
              status: 'draft'
            });
            
            await clearSavedPositions();
            
          } catch (error) {
            console.error('Помилка при перерахунку позицій:', error);
            alert('Помилка при перерахунку цін. Спробуйте ще раз.');
          } finally {
            setLoading(false);
            setIsRestoring(false);
          }
        },
        async () => {
          await clearSavedPositions();
          setIsRestoring(false);
        }
      );
    } else {
      
      console.log('Немає збережених позицій для відновлення');
    }
  } catch (error) {
    console.error('Помилка завантаження збережених позицій:', error);
    setIsRestoring(false);
  }
};
const repeatOrder = async (oldOrder) => {
  try {
    showConfirm('Створити нове замовлення на основі цього з перерахунком актуальних цін?', async () => {
      setLoading(true);
      const recalculatedItems = [];
      let recalculatedCount = 0;
      
      for (const item of oldOrder.items) {
        const recalculatedItem = await recalculateSavedItemPrice(item);
        recalculatedItems.push(recalculatedItem);
        recalculatedCount++;
        console.log(`Перераховано ${recalculatedCount} з ${oldOrder.items.length} позицій`);
      }

      const dealerDisplayName = contractorName || dealerName || 'Дилер';

      const newOrder = {
        id: null,
        dealer: dealerDisplayName,
        orderNumber: `ЗАМ-${nextOrderNumber.toString().padStart(3, '0')}`,
        date: new Date().toISOString().split('T')[0],
        items: recalculatedItems,
        notes: `Повтор замовлення ${oldOrder.orderNumber} від ${new Date(oldOrder.date).toLocaleDateString('uk-UA')}\n\n${oldOrder.notes || ''}`,
        status: 'draft'
      };

      setCurrentOrder(newOrder);
      setShowOrdersList(false);
      
      let priceChangedCount = 0;
      for (let i = 0; i < oldOrder.items.length && i < recalculatedItems.length; i++) {
        const oldPrice = oldOrder.items[i].price || 0;
        const newPrice = recalculatedItems[i].price || 0;
        if (Math.abs(oldPrice - newPrice) > 0.01) {
          priceChangedCount++;
        }
      }
      
      if (priceChangedCount > 0) {
        alert(`Створено нове замовлення на основі ${oldOrder.orderNumber}\nУ ${priceChangedCount} позиціях ціни змінено відповідно до актуального прайсу.`);
      } else {
        alert(`Створено нове замовлення на основі ${oldOrder.orderNumber} з актуальними цінами`);
      }
      
      setLoading(false);
    });
  } catch (error) {
    console.error('Помилка при повторенні замовлення:', error);
    alert('Помилка при створенні повторного замовлення');
    setLoading(false);
  }
};

const clearSavedPositions = async () => {
  if (!userId) return;
  
  try {
    await axios.delete(`https://test2.planfix-to-syrve.com/api/clear-order-positions/${userId}`);
    console.log('Збережені позиції очищено');
  } catch (error) {
    console.error('Помилка очищення позицій:', error);
  }
};

  

  












const clearDuplicateDrafts = async () => {
  if (!userId) return;
  
  try {
    const response = await axios.get(`https://test2.planfix-to-syrve.com/api/user-drafts/${userId}`);
    if (response.data.success) {
      const drafts = response.data.data;
      
      
      const uniqueMap = new Map();
      const duplicates = [];
      
      for (const draft of drafts) {
        const key = `${draft.systemName}_${draft.fabricCode}_${draft.width}_${draft.height}`;
        if (uniqueMap.has(key)) {
          duplicates.push(draft);
        } else {
          uniqueMap.set(key, draft);
        }
      }
      
      
      for (const duplicate of duplicates) {
        await axios.delete(`https://test2.planfix-to-syrve.com/api/draft/${userId}/${duplicate.id}`);
        console.log('🗑️ Видалено дублікат:', duplicate.id);
      }
      
      
      await fetchDrafts();
      alert(`Видалено ${duplicates.length} дублікатів`);
    }
  } catch (error) {
    console.error('Помилка очищення дублікатів:', error);
  }
};

  
  useEffect(() => {
    if (currentOrder.items.length > 0 || currentOrder.notes) {
      const timer = setTimeout(() => {
        savePositionsToFile(
          currentOrder.items, 
          currentOrder.orderNumber, 
          currentOrder.dealer, 
          currentOrder.notes, 
          currentOrder.status
        );
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [currentOrder.items, currentOrder.notes, currentOrder.orderNumber, currentOrder.dealer, currentOrder.status]);


  const fetchOrderDrafts = async () => {
  if (!userId) return;
  
  try {
    setLoadingOrderDrafts(true);
    const response = await axios.get(`https://test2.planfix-to-syrve.com/api/get-order-drafts/${userId}`);
    if (response.data.success) {
      setOrderDrafts(response.data.data);
    }
  } catch (error) {
    console.error('Помилка завантаження чернеток замовлень:', error);
  } finally {
    setLoadingOrderDrafts(false);
  }
};
const saveOrderAsDraft = async () => {
  if (currentOrder.items.length === 0) {
    alert('Немає позицій для збереження');
    return;
  }

  setSavingOrderDraft(true);
  
  try {
    const dealerDisplayName = contractorName || dealerName || 'Дилер';
    
    const orderData = {
      ...currentOrder,
      dealer: dealerDisplayName,
      userId: userId,
      savedAt: new Date().toISOString(),
      username: dealerName,
      userEmail,
      userPhone
    };

    const response = await axios.post(`https://test2.planfix-to-syrve.com/api/save-order-draft`, {
      userId: userId,
      orderData: orderData
    });

    if (response.data.success) {
      alert('Чернетку замовлення збережено!');
      await fetchOrderDrafts(); 
      setShowOrderDraftsList(true); 
    } else {
      alert('Помилка при збереженні чернетки: ' + (response.data.error || ''));
    }
  } catch (error) {
    console.error('Помилка збереження чернетки замовлення:', error);
    alert('Помилка при збереженні чернетки');
  } finally {
    setSavingOrderDraft(false);
  }
};
const loadOrderDraft = async (draftId) => {
  try {
    setLoading(true);
    const response = await axios.get(`https://test2.planfix-to-syrve.com/api/get-order-draft/${userId}/${draftId}`);
    
    if (response.data.success) {
      const draft = response.data.data;
      
      
      const recalculatedItems = [];
      for (const item of draft.items || []) {
        
        if (!item.basePrice && item.price) item.basePrice = item.price;
        if (!item.finalPrice && item.price) item.finalPrice = item.price;
        if (!item.accessoriesTotal) item.accessoriesTotal = 0;
        
        
        const recalculatedItem = await recalculateSavedItemPrice(item);
        recalculatedItems.push(recalculatedItem);
      }
      
      
      setCurrentOrder({
        id: draft.id || null,
        dealer: draft.dealer || dealerDisplayName,
        orderNumber: draft.orderNumber || currentOrder.orderNumber,
        date: draft.date || new Date().toISOString().split('T')[0],
        items: recalculatedItems,
        notes: draft.notes || '',
        status: 'draft'
      });
      
      
      setShowOrderDraftsList(false);
      
      
      await clearSavedPositions();
      
      
      const totalItems = recalculatedItems.length;
      const totalSum = recalculatedItems.reduce((sum, item) => {
        const itemSum = (item.price || 0) * (item.quantity || 1);
        return sum + itemSum;
      }, 0);
      
      alert(`Чернетку завантажено!\nПозицій: ${totalItems}\nСума: ${totalSum.toFixed(2)} €`);
    } else {
      alert('Помилка при завантаженні чернетки');
    }
  } catch (error) {
    console.error('Помилка завантаження чернетки:', error);
    alert('Помилка при завантаженні чернетки');
  } finally {
    setLoading(false);
  }
};


const deleteOrderDraft = async (draftId) => {
  if (!window.confirm('Ви впевнені, що хочете видалити цю чернетку замовлення?')) {
    return;
  }
  
  try {
    const response = await axios.delete(`https://test2.planfix-to-syrve.com/api/delete-order-draft/${userId}/${draftId}`);
    
    if (response.data.success) {
      
      setOrderDrafts(prev => prev.filter(draft => draft.draftId !== draftId));
      alert('Чернетку видалено');
    } else {
      alert('Помилка при видаленні чернетки');
    }
  } catch (error) {
    console.error('Помилка видалення чернетки:', error);
    alert('Помилка при видаленні чернетки');
  }
};

const useOrderDraft = async (draftId) => {
  if (!window.confirm('Завантажити цю чернетку? Поточне замовлення буде замінено.')) {
    return;
  }
  
  try {
    setLoading(true);
    const response = await axios.get(`https://test2.planfix-to-syrve.com/api/get-order-draft/${userId}/${draftId}`);
    
    if (response.data.success) {
      const draft = response.data.data;
      
      
      const recalculatedItems = [];
      for (const item of draft.items || []) {
        if (!item.basePrice && item.price) item.basePrice = item.price;
        if (!item.finalPrice && item.price) item.finalPrice = item.price;
        if (!item.accessoriesTotal) item.accessoriesTotal = 0;
        const recalculatedItem = await recalculateSavedItemPrice(item);
        recalculatedItems.push(recalculatedItem);
      }
      
      
      const nextNumber = getNextOrderNumber(orders);
      const newOrderNumber = `ЗАМ-${nextNumber.toString().padStart(3, '0')}`;
      
      
      setCurrentOrder({
        id: null,
        dealer: draft.dealer || dealerDisplayName,
        orderNumber: newOrderNumber,
        date: new Date().toISOString().split('T')[0],
        items: recalculatedItems,
        notes: draft.notes || '',
        status: 'draft'
      });
      
      
      await deleteOrderDraft(draftId);
      
      setShowOrderDraftsList(false);
      await clearSavedPositions();
      
      alert(`Чернетку завантажено!\nНове замовлення: ${newOrderNumber}\nПозицій: ${recalculatedItems.length}`);
    }
  } catch (error) {
    console.error('Помилка завантаження чернетки:', error);
    alert('Помилка при завантаженні чернетки');
  } finally {
    setLoading(false);
  }
};



const clearOrderDraftsAfterConfirm = async () => {
  try {
    const response = await axios.get(`https://test2.planfix-to-syrve.com/api/get-order-drafts/${userId}`);
    if (response.data.success && response.data.data.length > 0) {
      for (const draft of response.data.data) {
        await axios.delete(`https://test2.planfix-to-syrve.com/api/delete-order-draft/${userId}/${draft.draftId}`);
      }
      setOrderDrafts([]);
      console.log('Всі чернетки замовлень очищено після оформлення');
    }
  } catch (error) {
    console.error('Помилка очищення чернеток:', error);
  }
};


useEffect(() => {
  if (userId) {
    fetchOrderDrafts();
  }
}, [userId]);
  const fetchDrafts = async () => {
    try {
      setLoadingDrafts(true);
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/user-drafts/${userId}`);
      if (response.data.success) {
        setDraftItems(response.data.data);
      }
    } catch (error) {
      console.error('Помилка завантаження чернеток:', error);
    } finally {
      setLoadingDrafts(false);
    }
  };

  const getNextOrderNumber = (existingOrders) => {
    if (!existingOrders || existingOrders.length === 0) {
      return 1;
    }
    const maxNumber = Math.max(...existingOrders.map(order => {
      const match = order.orderNumber?.match(/ЗАМ-(\d+)/);
      return match ? parseInt(match[1]) : 0;
    }));
    return maxNumber + 1;
  };

  const roundToNextAvailable = (value, availableValues) => {
    if (!availableValues || availableValues.length === 0) return parseFloat(value);
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return value;
    const sorted = [...availableValues].sort((a, b) => a - b);
    for (let i = 0; i < sorted.length; i++) {
      if (sorted[i] >= numValue - 0.01) {
        return sorted[i];
      }
    }
    return sorted[sorted.length - 1];
  };

  useEffect(() => {
    const systemsWithBoxHeight = [
      'Зебра Мінікасета М19',
      'Зебра Мінікасета М19 окремий прайс',
      'Зебра Мінікасета М19 пластик',
      'Зебра Мінікасета М19 пластик окремий прайс',
      'Зебра Мінікасета М19 пластик широкі напрямні'
    ];
    const show = systemsWithBoxHeight.some(s => currentItem.systemName.includes(s));
    setShowBoxHeight(show);
    setRequiredFields(prev => ({ ...prev, boxHeight: show }));
  }, [currentItem.systemName]);

  useEffect(() => {
    const show = currentItem.systemName.includes('МП');
    setShowMountingType(show);
    setRequiredFields(prev => ({ ...prev, mountingType: show }));
  }, [currentItem.systemName]);

  useEffect(() => {
    if (currentItem.systemType && systemSearch.trim() === '') {
      setShowSystemDropdown(false);
    }
  }, [currentItem.systemType]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (systemSearchRef.current && !systemSearchRef.current.contains(event.target)) {
        setShowSystemDropdown(false);
      }
      if (mountingTypeRef.current && !mountingTypeRef.current.contains(event.target)) {
        setShowMountingDropdown(false);
      }
      if (controlSideRef.current && !controlSideRef.current.contains(event.target)) {
        setShowControlSideDropdown(false);
      }
      if (colorRef.current && !colorRef.current.contains(event.target)) {
        setShowColorDropdown(false);
      }
      if (systemTypeRef.current && !systemTypeRef.current.contains(event.target)) {
        setShowSystemTypeDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSystemSearchChange = (e) => {
    const value = e.target.value;
    setSystemSearch(value);
    let systemsToFilter = [];
    if (currentItem.systemType) {
      systemsToFilter = categories[currentItem.systemType] || [];
    } else {
      systemsToFilter = systems;
    }
    const filtered = systemsToFilter.filter(s => 
      s !== currentItem.systemName && s.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredSystems(filtered);
    setShowSystemDropdown(value.length > 0 && filtered.length > 0);
  };

  const handleSystemFocus = () => {
    let systemsToShow = [];
    if (currentItem.systemType) {
      systemsToShow = categories[currentItem.systemType] || [];
    } else {
      systemsToShow = systems;
    }
    setFilteredSystems(systemsToShow.filter(s => s !== currentItem.systemName));
    setShowSystemDropdown(true);
  };
  const handleSystemSelect = (system) => {
    setCurrentItem(prev => ({ 
      ...prev, 
      systemName: system, 
      fabricCode: '', 
      fabricColor: '' 
    }));
    setSystemSearch(system);
    setShowSystemDropdown(false);
    setValidationErrors({});
    
    
    setAccessoriesItems([]);
    setShowAccessoriesPanel(false);
    setNewAccessory({
      name: '',
      quantity: 1,
      price: 0,
      sum: 0,
      quantityError: false
    });
    setAccessorySearch('');
    setShowAccessoryDropdown(false);
  };

  const handleMountingSearchChange = (e) => {
    const value = e.target.value;
    setMountingSearch(value);
    if (value === '') {
      setCurrentItem(prev => ({ ...prev, mountingType: '' }));
    }
    const filtered = mountingTypes2.filter(m => 
      m.label.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredMountings(filtered);
    setShowMountingDropdown(value.length > 0 && filtered.length > 0);
  };

  const handleMountingFocus = () => {
    setFilteredMountings(mountingTypes2);
    setShowMountingDropdown(true);
  };

  const handleMountingSelect = (mounting) => {
    setCurrentItem(prev => ({ ...prev, mountingType: mounting.value }));
    setMountingSearch(mounting.label);
    setShowMountingDropdown(false);
    setValidationErrors(prev => ({ ...prev, mountingType: '' }));
  };

  const handleControlSideSearchChange = (e) => {
    const value = e.target.value;
    setControlSideSearch(value);
    if (value === '') {
      setCurrentItem(prev => ({ ...prev, controlSide: '' }));
    }
    setValidationErrors(prev => ({ ...prev, controlSide: '' }));
    const filtered = controlSideOptions.filter(c => 
      c.label.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredControlSides(filtered);
    setShowControlSideDropdown(value.length > 0 && filtered.length > 0);
  };

  const handleControlSideFocus = () => {
    setFilteredControlSides(controlSideOptions);
    setShowControlSideDropdown(true);
  };

  const handleControlSideSelect = (control) => {
    setCurrentItem(prev => ({ ...prev, controlSide: control.value }));
    setControlSideSearch(control.label);
    setShowControlSideDropdown(false);
    setValidationErrors(prev => ({ ...prev, controlSide: '' }));
  };

  const handleSystemTypeSearchChange = (e) => {
    const value = e.target.value;
    setSystemTypeSearch(value);
    if (value === '') {
      setCurrentItem(prev => ({ ...prev, systemType: '' }));
    }
    const systemTypes = Object.keys(categories);
    const filtered = systemTypes.filter(type => 
      type.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredSystemTypes(filtered);
    setShowSystemTypeDropdown(value.length > 0 && filtered.length > 0);
  };

  const handleSystemTypeFocus = () => {
    const systemTypes = Object.keys(categories);
    setFilteredSystemTypes(systemTypes);
    setShowSystemTypeDropdown(true);
  };

  const handleSystemTypeSelect = (systemType) => {
    setCurrentItem(prev => ({ ...prev, systemType: systemType, systemName: '' }));
    setSystemTypeSearch(systemType);
    setSystemSearch('');
    setShowSystemTypeDropdown(false);
    setValidationErrors(prev => ({ ...prev, systemType: '' }));
  };

  const [filteredMountings, setFilteredMountings] = useState(mountingTypes2);
  const [filteredControlSides, setFilteredControlSides] = useState(controlSideOptions);

  const fetchFabricsWithImages = async (search = '') => {
    try {
      setLoadingFabrics(true);
      let systemTypeFilter = '';
      if (currentItem.systemType) {
        const systemTypeMap = {
          '3D Зебра': '3D Зебра',
          'Зебра': 'Зебра',
          'Римські': 'Римські',
          'Ролетні': 'Ролети',
          'Марево': 'Марево'
        };
        systemTypeFilter = systemTypeMap[currentItem.systemType] || '';
      }
      const url = `https://test2.planfix-to-syrve.com/api/fabrics-with-images${search ? `?search=${encodeURIComponent(search)}` : ''}${systemTypeFilter ? `${search ? '&' : '?'}systemType=${encodeURIComponent(systemTypeFilter)}` : ''}`;
      const response = await axios.get(url);
      if (response.data.success) {
        setFabricsWithImages(response.data.data);
        setFilteredFabrics(response.data.data);
      }
    } catch (error) {
      console.error('Помилка завантаження тканин з фото:', error);
    } finally {
      setLoadingFabrics(false);
    }
  };

  const fetchSystemFabrics = async (systemName) => {
    try {
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/system-fabrics/${encodeURIComponent(systemName)}`);
      if (response.data.success) {
        setAvailableFabrics(response.data.data.fabrics);
        setSystemType(response.data.data.systemType);
      }
    } catch (error) {
      console.error('Помилка завантаження тканин для системи:', error);
      setAvailableFabrics([]);
    }
  };

  const fetchSystemColors = async (systemName) => {
    try {
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/system-colors/${encodeURIComponent(systemName)}`);
      if (response.data.success) {
        setAvailableColors(response.data.data.colors);
      } else {
        setAvailableColors([]);
      }
    } catch (error) {
      console.error('Помилка завантаження кольорів для системи:', error);
      setAvailableColors([]);
    }
  };

  const fetchSystemParams = async (systemName) => {
    try {
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/system-params/${encodeURIComponent(systemName)}`);
      if (response.data.success) {
        setSystemParams(response.data.data);
      }
    } catch (error) {
      console.error('Помилка завантаження параметрів:', error);
    }
  };

  const getQualityFromFabricCode = (fabricCode) => {
    if (!fabricCode) return '';
    const qualityMatch = fabricCode.match(/[A-Z]/);
    if (qualityMatch) {
      return qualityMatch[0].toLowerCase();
    }
    return '';
  };

  const isValueInRange = (value, min, max) => {
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return false;
    return numValue >= min && numValue <= max;
  };
  
  
  const isHeightValid = (value) => {
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return false;
    return numValue > 0;
  };

  const validateRequiredFields = () => {
    const errors = {};
    if (!currentItem.systemType) errors.systemType = 'Виберіть тип системи';
    if (!currentItem.systemName) errors.systemName = 'Виберіть назву системи';
    if (!currentItem.fabricCode) errors.fabricCode = 'Виберіть код тканини';
    if (!currentItem.fabricColor) errors.fabricColor = 'Виберіть колір системи';
    if (!currentItem.width) errors.width = 'Вкажіть ширину';
    if (!currentItem.height) errors.height = 'Вкажіть висоту';
    if (!currentItem.quantity || currentItem.quantity < 1) errors.quantity = 'Кількість має бути більше 0';
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const calculatePrice = async () => {
    if (!currentItem.systemName || !currentItem.fabricCode || !currentItem.fabricColor || 
        !currentItem.fabricQuality || !currentItem.width || !currentItem.height) {
      return;
    }
    if (!validateRequiredFields()) return;
    
    setPriceCalculation({ loading: true, result: null, error: null, warnings: [] });
    
    try {
      let roundedWidth = parseFloat(currentItem.width);
      let roundedHeight = parseFloat(currentItem.height);
      let widthRounded = false;
      let heightRounded = false;
      let originalHeight = parseFloat(currentItem.height);
      let originalWidth = parseFloat(currentItem.width);
      
      
      if (systemParams && systemParams.widthRange?.available) {
        const nextWidth = roundToNextAvailable(roundedWidth, systemParams.widthRange.available);
        if (Math.abs(nextWidth - roundedWidth) > 0.01) {
          roundedWidth = nextWidth;
          widthRounded = true;
        }
      }
      
      
      if (systemParams && systemParams.availableHeights && systemParams.availableHeights.length > 0) {
        const sortedHeights = [...systemParams.availableHeights].sort((a, b) => a - b);
        const minHeight = sortedHeights[0];
        const maxHeight = sortedHeights[sortedHeights.length - 1];
        
        
        if (roundedHeight < minHeight) {
          roundedHeight = minHeight;
          heightRounded = true;
        } 
        
        else if (roundedHeight > maxHeight) {
          roundedHeight = maxHeight;
          heightRounded = true;
        }
        
        else {
          const nextHeight = roundToNextAvailable(roundedHeight, systemParams.availableHeights);
          if (Math.abs(nextHeight - roundedHeight) > 0.01) {
            roundedHeight = nextHeight;
            heightRounded = true;
          }
        }
      }
      
      const heightInMeters = roundedHeight / 100;
      
      const response = await axios.post(`https://test2.planfix-to-syrve.com/api/calculate-price`, {
        systemName: currentItem.systemName,
        height: heightInMeters,
        width: parseInt(roundedWidth),
        quality: currentItem.fabricQuality,
        fabricCode: currentItem.fabricCode,
        color: currentItem.fabricColor,
        userId: userId,
        originalWidth: currentItem.width,
        originalHeight: currentItem.height,
        roundedWidth,
        roundedHeight,
        widthRounded,
        heightRounded
      });
      
      const data = response.data;
      
      if (data.success) {
        
        const accessoriesTotal = accessoriesItems.reduce((sum, acc) => sum + (acc.price * acc.quantity), 0);
        const systemBasePrice = data.data.basePrice;
        const systemFinalPrice = data.data.finalPrice;
        
        
        const totalBeforeDiscount = (systemBasePrice * currentItem.quantity) + accessoriesTotal;
        
        const totalAfterSystemDiscount = (systemFinalPrice * currentItem.quantity) + accessoriesTotal;
        
        
        const discountAmount = totalBeforeDiscount - totalAfterSystemDiscount;
        
        setPriceCalculation({
          loading: false,
          result: { 
            ...data.data, 
            roundedWidth, 
            roundedHeight, 
            widthRounded, 
            heightRounded, 
            originalWidth: currentItem.width, 
            originalHeight: currentItem.height,
            accessoriesTotal: accessoriesTotal,
            systemBasePrice: systemBasePrice,
            systemFinalPrice: systemFinalPrice,
            totalBeforeDiscount: totalBeforeDiscount,
            totalAfterDiscount: totalAfterSystemDiscount,
            discountAmount: discountAmount
          },
          error: null,
          warnings: data.warnings || []
        });
        setPriceType(data.data.priceType);
        setShowPriceResult(true);
        setCurrentItem(prev => ({ 
          ...prev, 
          price: data.data.basePrice, 
          sum: totalAfterSystemDiscount
        }));
      } else {
        setPriceCalculation({ loading: false, result: null, error: data.error, warnings: [] });
        setShowPriceResult(false);
      }
    } catch (error) {
      console.error('Помилка розрахунку:', error);
      setPriceCalculation({ loading: false, result: null, error: 'Помилка при розрахунку ціни', warnings: [] });
      setShowPriceResult(false);
    }
  };
  useEffect(() => {
    if (currentItem.systemName && currentItem.fabricCode && currentItem.fabricColor && 
        currentItem.fabricQuality && currentItem.width && currentItem.height) {
      if (systemParams) {
        const widthInRange = isValueInRange(currentItem.width, systemParams.widthRange.min, systemParams.widthRange.max);
        const heightValid = isHeightValid(currentItem.height);
        setRangeErrors({ width: !widthInRange, height: !heightValid });
        if (widthInRange && heightValid && validateRequiredFields()) {
          const timer = setTimeout(() => calculatePrice(), 500);
          return () => clearTimeout(timer);
        } else {
          setShowPriceResult(false);
          setPriceCalculation({ loading: false, result: null, error: null, warnings: [] });
        }
      }
    } else {
      setShowPriceResult(false);
      setPriceCalculation({ loading: false, result: null, error: null, warnings: [] });
      setRangeErrors({ width: false, height: false });
    }
  }, [currentItem.systemName, currentItem.fabricCode, currentItem.fabricColor, currentItem.fabricQuality, currentItem.width, currentItem.height, systemParams, currentItem.mountingType, currentItem.boxHeight, currentItem.controlSide, accessoriesItems]);
  
  useEffect(() => {
    fetchUserData();
    fetchContractorData();
    fetchSystems();
    fetchUserDiscount();
    fetchUserOrders();
    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (showOrdersList) fetchUserOrders();
  }, [showOrdersList]);

  useEffect(() => {
    const dealerDisplayName = contractorName || dealerName || 'Дилер';
    if (dealerDisplayName && dealerDisplayName !== 'Завантаження...') {
      if (orders.length > 0) {
        const maxOrderNumber = Math.max(...orders.map(order => {
          const match = order.orderNumber?.match(/ЗАМ-(\d+)/);
          return match ? parseInt(match[1]) : 0;
        }));
        const nextNum = maxOrderNumber + 1;
        setNextOrderNumber(nextNum);
        setCurrentOrder(prev => ({ ...prev, dealer: dealerDisplayName, orderNumber: `ЗАМ-${nextNum.toString().padStart(3, '0')}` }));
      } else {
        setNextOrderNumber(1);
        setCurrentOrder(prev => ({ ...prev, dealer: dealerDisplayName, orderNumber: 'ЗАМ-001' }));
      }
    }
  }, [orders, contractorName, dealerName]);

  useEffect(() => {
    if (currentItem.systemName) {
      fetchSystemParams(currentItem.systemName);
      fetchSystemFabrics(currentItem.systemName);
      fetchSystemColors(currentItem.systemName);
      const foundCategory = Object.entries(categories).find(([cat, sysList]) => sysList.includes(currentItem.systemName));
      if (foundCategory) {
        const [category] = foundCategory;
        if (currentItem.systemType !== category) {
          setCurrentItem(prev => ({ ...prev, systemType: category }));
          setSystemTypeSearch(category);
        }
      }
      setShowPriceResult(false);
      setPriceCalculation({ loading: false, result: null, error: null, warnings: [] });
      setRangeErrors({ width: false, height: false });
    } else {
      setSystemParams(null);
      setAvailableFabrics([]);
      setAvailableColors([]);
      setAvailableQualities(['z', 'a', 'b', 'c', 'd', 'e', 'f']);
      setSystemType('');
      setShowControlFields(false);
      setShowPriceResult(false);
      setPriceCalculation({ loading: false, result: null, error: null, warnings: [] });
      setRangeErrors({ width: false, height: false });
    }
  }, [currentItem.systemName, categories]);

  useEffect(() => {
    if (currentItem.fabricCode) {
      const quality = getQualityFromFabricCode(currentItem.fabricCode);
      if (quality) setCurrentItem(prev => ({ ...prev, fabricQuality: quality }));
    }
  }, [currentItem.fabricCode]);

  const fetchUserInfo = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) setUserToken(token);
      const response = await axios.get(`https://test2.planfix-to-syrve.com/user-info/${userId}`);
      if (response.data.success) {
        setUserEmail(response.data.data.email || '');
        setUserPhone(response.data.data.phone || '');
        setUserToken(response.data.data.token || '');
      }
    } catch (error) {
      console.error('Помилка завантаження інформації користувача:', error);
    }
  };

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://test2.planfix-to-syrve.com/current-user/${userId}`);
      if (response?.data) {
        if (response.data.contractorName) setDealerName(response.data.contractorName);
        else setDealerName(response.data.username || 'Дилер');
        if (response.data.email) setUserEmail(response.data.email);
        if (response.data.phone) setUserPhone(response.data.phone);
        if (response.data.token) setUserToken(response.data.token);
        if (response.data.discount) setUserDiscount(response.data.discount);
      }
    } catch (error) {
      setAuthError('Помилка завантаження даних користувача');
    }
  };
  
  const fetchContractorData = async () => {
    try {
      const response = await axios.get(`https://test2.planfix-to-syrve.com/user-contractor/${userId}`);
      if (response.data && response.data.name) {
        setContractorName(response.data.name);
        setDealerName(response.data.name);
      } else {
        setContractorName(null);
      }
    } catch (error) {
      console.error('Помилка завантаження даних контрагента:', error);
      setContractorName(null);
    }
  };

  const fetchUserDiscount = async () => {
    try {
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/user-discount/${userId}`);
      if (response.data?.success) setUserDiscount(response.data.data.discount);
    } catch (error) {
      console.error('Помилка завантаження знижки:', error);
    }
  };

  const fetchSystems = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/available-systems-from-colors`);
      if (response.data.success) {
        setSystems(response.data.data.all);
        setCategories(response.data.data.categories);
      }
    } catch (error) {
      console.error('Помилка завантаження систем:', error);
      setError('Не вдалося завантажити список систем');
    } finally {
      setLoading(false);
    }
  };

  const fetchUserOrders = async () => {
    try {
      const response = await axios.get(`https://test2.planfix-to-syrve.com/api/user-orders/${userId}`);
      if (response.data.success) setOrders(response.data.data);
    } catch (error) {
      console.error('Помилка завантаження замовлень:', error);
    }
  };

  const openFabricModal = () => {
    if (!currentItem.systemName) {
      alert('Спочатку виберіть систему');
      return;
    }
    setShowFabricModal(true);
    setFabricSearch('');
    setSelectedFabric(null);
    fetchFabricsWithImages();
  };

  const closeFabricModal = () => {
    setShowFabricModal(false);
    setFabricSearch('');
    setSelectedFabric(null);
  };

  const selectFabric = (fabric) => setSelectedFabric(fabric);

  const confirmFabricSelection = () => {
    if (selectedFabric) {
      setCurrentItem(prev => ({ ...prev, fabricCode: selectedFabric.code }));
      const quality = getQualityFromFabricCode(selectedFabric.code);
      if (quality) setCurrentItem(prev => ({ ...prev, fabricQuality: quality }));
      setValidationErrors({});
      closeFabricModal();
    }
  };

  const handleFabricSearch = (e) => {
    const searchValue = e.target.value;
    setFabricSearch(searchValue);
    if (searchValue.trim()) {
      const filtered = fabricsWithImages.filter(item => 
        item.code.toLowerCase().includes(searchValue.toLowerCase()) || 
        (item.fabricType && item.fabricType.toLowerCase().includes(searchValue.toLowerCase())) ||
        (item.label && item.label.toLowerCase().includes(searchValue.toLowerCase()))
      );
      setFilteredFabrics(filtered);
    } else {
      setFilteredFabrics(fabricsWithImages);
    }
  };

  const validateItemForAdd = () => {
    const errors = {};
    
    
    if (!currentItem.systemType || currentItem.systemType.trim() === '') {
      errors.systemType = 'Виберіть тип системи';
    }
    if (!currentItem.systemName || currentItem.systemName.trim() === '') {
      errors.systemName = 'Виберіть систему';
    }
    if (!currentItem.fabricCode || currentItem.fabricCode.trim() === '') {
      errors.fabricCode = 'Виберіть код тканини';
    }
    if (!currentItem.fabricColor || currentItem.fabricColor.trim() === '') {
      errors.fabricColor = 'Виберіть колір';
    }
    if (!currentItem.width || currentItem.width.trim() === '' || parseFloat(currentItem.width) <= 0) {
      errors.width = 'Вкажіть ширину';
    }
    if (!currentItem.height || currentItem.height.trim() === '' || parseFloat(currentItem.height) <= 0) {
      errors.height = 'Вкажіть висоту';
    }
    if (!currentItem.quantity || currentItem.quantity < 1) {
      errors.quantity = 'Кількість має бути більше 0';
    }
    if (!currentItem.controlSide || currentItem.controlSide.trim() === '') {
      errors.controlSide = 'Виберіть сторону управління';
    }
    
    
    if (showMountingType && (!currentItem.mountingType || currentItem.mountingType.trim() === '')) {
      errors.mountingType = 'Обов\'язково виберіть тип монтажу';
    }
    if (showBoxHeight && (!currentItem.boxHeight || currentItem.boxHeight.trim() === '' || parseFloat(currentItem.boxHeight) === 0)) {
      errors.boxHeight = 'Обов\'язково вкажіть висоту короба/обтяжувача';
    }
    
    
    if (rangeErrors.width) {
      errors.widthRange = 'Введено недопустимий діапазон';
    }
    if (rangeErrors.height) {
      errors.heightRange = 'Введено недопустимий діапазон';
    }
    
    setValidationErrors(errors);
    return Object.keys(errors).length === 0 && !rangeErrors.width && !rangeErrors.height;
  };

  const saveAsDraft = async () => {
    let currentSystemType = currentItem.systemType;
    if (!currentSystemType && currentItem.systemName && categories) {
      const foundCategory = Object.entries(categories).find(([cat, sysList]) => sysList.includes(currentItem.systemName));
      if (foundCategory) currentSystemType = foundCategory[0];
    }
    
    
    const accessoriesArray = accessoriesItems.map(acc => ({
      name_add: acc.name,
      coloradd: currentItem.fabricColor || '',
      basePriceadd: acc.price.toString(),
      amountadd: acc.quantity.toString(),
      name: acc.name,           
      price: acc.price,         
      quantity: acc.quantity    
    }));
    
    console.log('Зберігаємо чернетку з додатками:', accessoriesArray);
    
    const draftItem = {
      id: `draft_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      ...currentItem,
      systemType: currentSystemType,
      add: accessoriesArray,
      accessoriesItems: accessoriesArray,  
      draft: true,
      createdAt: new Date().toISOString()
    };
    
    try {
      const response = await axios.post(`https://test2.planfix-to-syrve.com/api/save-draft`, { userId, draft: draftItem });
      if (response.data.success) {
        setDraftItems(prev => [response.data.data, ...prev]);
        resetFormAfterEdit();
        alert('Чернетка позиції збережена!');
      }
    } catch (error) {
      console.error('Помилка збереження чернетки:', error);
      alert('Помилка при збереженні чернетки');
    }
  };
  const editDraftItem = (draftItem) => {
    console.log('=== РЕДАГУВАННЯ ЧЕРНЕТКИ ===');
    console.log('Дані чернетки:', draftItem);
    console.log('Додатки (add):', draftItem.add);
    
    let foundSystemType = draftItem.systemType || '';
    if (!foundSystemType && draftItem.systemName && categories) {
      const foundCategory = Object.entries(categories).find(([cat, sysList]) => sysList.includes(draftItem.systemName));
      if (foundCategory) foundSystemType = foundCategory[0];
    }
    
    
    const safeBasePrice = draftItem.basePrice || draftItem.price || 0;
    const safeFinalPrice = draftItem.finalPrice || (draftItem.priceCalculation?.finalPrice) || draftItem.price || 0;
    const safeQuantity = draftItem.quantity || 1;
    
    
    const loadedAccessories = [];
    
    
    if (draftItem.add && Array.isArray(draftItem.add) && draftItem.add.length > 0) {
      console.log('Завантаження додатків з чернетки (add):', draftItem.add);
      for (let idx = 0; idx < draftItem.add.length; idx++) {
        const acc = draftItem.add[idx];
        const price = parseFloat(acc.basePriceadd) || parseFloat(acc.price) || 0;
        const qty = parseInt(acc.amountadd) || parseInt(acc.quantity) || 1;
        loadedAccessories.push({
          id: Date.now() + idx,
          name: acc.name_add || acc.name,
          quantity: qty,
          price: price,
          sum: price * qty
        });
      }
    }
    
    
    if (loadedAccessories.length === 0 && draftItem.accessoriesItems && Array.isArray(draftItem.accessoriesItems) && draftItem.accessoriesItems.length > 0) {
      console.log('Завантаження додатків з чернетки (accessoriesItems):', draftItem.accessoriesItems);
      for (let idx = 0; idx < draftItem.accessoriesItems.length; idx++) {
        const acc = draftItem.accessoriesItems[idx];
        const price = parseFloat(acc.price) || parseFloat(acc.basePriceadd) || 0;
        const qty = parseInt(acc.quantity) || parseInt(acc.amountadd) || 1;
        loadedAccessories.push({
          id: Date.now() + idx,
          name: acc.name || acc.name_add,
          quantity: qty,
          price: price,
          sum: price * qty
        });
      }
    }
    
    console.log('Завантажено додатків з чернетки:', loadedAccessories.length);
    console.log('Додатки:', loadedAccessories);
    
    const accessoriesTotal = loadedAccessories.reduce((sum, acc) => sum + (acc.price * acc.quantity), 0);
    
    
    const safeSum = draftItem.sum || ((safeBasePrice * safeQuantity) + accessoriesTotal);
    const safeFinalSum = draftItem.finalSum || ((safeFinalPrice * safeQuantity) + accessoriesTotal);
    
    
    setCurrentItem({
      number: currentOrder.items.length + 1,
      systemType: foundSystemType,
      systemName: draftItem.systemName || '',
      fabricCode: draftItem.fabricCode || '',
      fabricQuality: draftItem.fabricQuality || '',
      fabricColor: draftItem.fabricColor || '',
      width: draftItem.width || '',
      height: draftItem.height || '',
      boxHeight: draftItem.boxHeight || '',
      mountingType: draftItem.mountingType || '',
      controlSide: draftItem.controlSide === '-' ? '' : (draftItem.controlSide || ''),
      controlLength: draftItem.controlLength || '',
      quantity: safeQuantity,
      price: safeBasePrice,
      sum: safeSum,
      itemNotes: draftItem.itemNotes || ''
    });
    
    
    
    setAccessoriesItems([]);
    
    
    if (loadedAccessories.length > 0) {
      setTimeout(() => {
        setAccessoriesItems(loadedAccessories);
        setShowAccessoriesPanel(true);
      }, 100);
    } else {
      setShowAccessoriesPanel(false);
    }
    
    
    setSystemSearch(draftItem.systemName || '');
    setSystemTypeSearch(foundSystemType);
    const mountingLabel = mountingTypes2.find(m => m.value === draftItem.mountingType)?.label || '';
    setMountingSearch(mountingLabel);
    const controlSideLabel = controlSideOptions.find(c => c.value === draftItem.controlSide)?.label || '';
    setControlSideSearch(controlSideLabel);
    setColorSearch(draftItem.fabricColor || '');
    setEditingItemIndex(null);
    
    
    if (draftItem.priceCalculation) {
      setPriceCalculation({
        loading: false,
        result: {
          ...draftItem.priceCalculation,
          systemBasePrice: draftItem.priceCalculation.systemBasePrice || safeBasePrice,
          systemFinalPrice: draftItem.priceCalculation.systemFinalPrice || safeFinalPrice,
          basePrice: draftItem.priceCalculation.basePrice || safeBasePrice,
          finalPrice: draftItem.priceCalculation.finalPrice || safeFinalPrice,
          accessoriesTotal: accessoriesTotal,
          totalBeforeDiscount: draftItem.priceCalculation.totalBeforeDiscount || safeSum,
          totalAfterDiscount: draftItem.priceCalculation.totalAfterDiscount || safeFinalSum
        },
        error: null,
        warnings: []
      });
      setShowPriceResult(true);
    } else {
      setPriceCalculation({
        loading: false,
        result: {
          systemBasePrice: safeBasePrice,
          systemFinalPrice: safeFinalPrice,
          basePrice: safeBasePrice,
          finalPrice: safeFinalPrice,
          accessoriesTotal: accessoriesTotal,
          totalBeforeDiscount: safeSum,
          totalAfterDiscount: safeFinalSum
        },
        error: null,
        warnings: []
      });
      setShowPriceResult(true);
    }
    
    
    deleteDraftItem(draftItem.id, false);
  };

  const deleteDraftItem = async (draftId, showConfirmation = true) => {
    const deleteAction = async () => {
      try {
        await axios.delete(`https://test2.planfix-to-syrve.com/api/draft/${userId}/${draftId}`);
        setDraftItems(prev => prev.filter(item => item.id !== draftId));
        if (showConfirmation) alert('Чернетку видалено');
      } catch (error) {
        console.error('Помилка видалення чернетки:', error);
        alert('Помилка при видаленні чернетки');
      }
    };
    if (showConfirmation) {
      showConfirm('Видалити цю чернетку?', deleteAction);
    } else {
      deleteAction();
    }
  };

  const resetFormAfterEdit = () => {
    setCurrentItem({
      number: currentOrder.items.length + 1,
      systemType: '', 
      systemName: '', 
      fabricCode: '', 
      fabricQuality: '', 
      fabricColor: '',
      width: '', 
      height: '', 
      boxHeight: '', 
      mountingType: '', 
      controlSide: '', 
      controlLength: '',
      quantity: 1, 
      price: 0, 
      sum: 0, 
      itemNotes: ''
    });
    setSystemSearch('');
    setSystemTypeSearch('');
    setMountingSearch('');
    setControlSideSearch('');
    setColorSearch('');
    setPriceCalculation({ loading: false, result: null, error: null, warnings: [] });
    setShowPriceResult(false);
    setValidationErrors({});
    setRangeErrors({ width: false, height: false });
    setShowSystemDropdown(false);
    setShowSystemTypeDropdown(false);
    setShowMountingDropdown(false);
    setShowControlSideDropdown(false);
    setShowColorDropdown(false);
    setAccessoriesItems([]);
    setShowAccessoriesPanel(false);
    setEditingItemIndex(null);
    setNewAccessory({
      name: '',
      quantity: 1,
      price: 0,
      sum: 0,
      quantityError: false
    });
    setAccessorySearch('');
    setFilteredAccessories([]);
    setShowAccessoryDropdown(false);
  };
  

  const addItemToOrderWithConfirm = () => {
    
    if (!validateItemForAdd()) {
      const firstErrorField = document.querySelector('.error');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstErrorField.focus();
      }
      return;
    }
    
    
    if (!priceCalculation.result) {
      setPriceCalculation(prev => ({ ...prev, error: 'Не вдалося розрахувати ціну' }));
      return;
    }
    
    
    const accessoriesTotal = accessoriesItems.reduce((sum, acc) => sum + (acc.price * acc.quantity), 0);
    const systemBasePrice = priceCalculation.result.systemBasePrice;
    const systemFinalPrice = priceCalculation.result.systemFinalPrice;
    const totalBeforeDiscount = (systemBasePrice * currentItem.quantity) + accessoriesTotal;
    const totalAfterDiscount = (systemFinalPrice * currentItem.quantity) + accessoriesTotal;
    const discountAmount = totalBeforeDiscount - totalAfterDiscount;
    
    
    const lines = [
      { label: 'Система:', value: `${currentItem.systemName}${currentItem.fabricColor ? `, ${currentItem.fabricColor}` : ''}` },
      { label: 'Код тканини:', value: currentItem.fabricCode },
      { label: 'Розміри:', value: `${currentItem.width} x ${currentItem.height} см` },
      { label: 'Кількість:', value: `${currentItem.quantity} шт.` },
      { label: 'Сторона управління:', value: currentItem.controlSide === 'left' ? 'Ліва' : 'Права' },
      { label: 'Ціна за од.:', value: `${systemBasePrice.toFixed(2)} € за шт.` }
    ];
    
    
    if (accessoriesTotal > 0) {
      lines.push({ label: 'Вартість дод.:', value: `${accessoriesTotal.toFixed(2)} €` });
    }
    
    


    
    
    lines.push({ label: 'Сума зі знижкою:', value: `${totalAfterDiscount.toFixed(2)} €` });
    
    const message = lines.map(line => `${line.label.padEnd(20)} ${line.value}`).join('\n');
    
    if (editingItemIndex !== null) {
      showConfirm(message, updateItemInOrder);
    } else {
      showConfirm(message, addItemToOrder);
    }
  };

const updateOldItemsPrices = async () => {
  const updatedItems = [];
  let needsUpdate = false;
  
  for (const item of currentOrder.items) {
    
    if (!item.priceCalculation?.totalAfterDiscount && item.price) {
      needsUpdate = true;
      
      const updatedItem = {
        ...item,
        priceCalculation: {
          systemBasePrice: item.basePrice || item.price,
          systemFinalPrice: item.finalPrice || item.price,
          basePrice: item.basePrice || item.price,
          finalPrice: item.finalPrice || item.price,
          totalBeforeDiscount: (item.basePrice || item.price) * (item.quantity || 1),
          totalAfterDiscount: (item.finalPrice || item.price) * (item.quantity || 1)
        }
      };
      updatedItems.push(updatedItem);
    } else {
      updatedItems.push(item);
    }
  }
  
  if (needsUpdate) {
    setCurrentOrder(prev => ({ ...prev, items: updatedItems }));
    savePositionsToFile(updatedItems, currentOrder.orderNumber, currentOrder.dealer, currentOrder.notes, currentOrder.status);
  }
};


useEffect(() => {
  if (currentOrder.items.length > 0) {
    updateOldItemsPrices();
  }
}, [currentOrder.orderNumber]);


useEffect(() => {
  if (currentOrder.items.length > 0) {
    updateOldItemsPrices();
  }
}, [currentOrder.orderNumber]);
const addItemToOrder = () => {
  const fabricLabel = currentItem.fabricCode;
  const dealerDisplayName = contractorName || dealerName || 'Дилер';
  let currentSystemType = currentItem.systemType;
  if (!currentSystemType && currentItem.systemName && categories) {
    const foundCategory = Object.entries(categories).find(([cat, sysList]) => sysList.includes(currentItem.systemName));
    if (foundCategory) currentSystemType = foundCategory[0];
  }
  
  
  const accessoriesTotal = accessoriesItems.reduce((sum, acc) => sum + (acc.price * acc.quantity), 0);
  
  
  const systemBasePrice = priceCalculation.result.systemBasePrice || priceCalculation.result.basePrice;
  
  const systemFinalPrice = priceCalculation.result.systemFinalPrice || priceCalculation.result.finalPrice;
  
  
  const baseSum = (systemBasePrice * currentItem.quantity) + accessoriesTotal;
  
  const finalSum = (systemFinalPrice * currentItem.quantity) + accessoriesTotal;
  
  
  const accessoriesArray = accessoriesItems.length > 0 ? accessoriesItems.map(acc => ({
    name_add: acc.name,
    coloradd: currentItem.fabricColor || '',
    basePriceadd: acc.price.toString(),
    amountadd: acc.quantity.toString(),
    name: acc.name,
    price: acc.price,
    quantity: acc.quantity
  })) : [];
  
  const newItem = {
    ...currentItem,
    systemType: currentSystemType,
    number: currentOrder.items.length + 1,
    quantity: currentItem.quantity,
    basePrice: systemBasePrice,
    finalPrice: systemFinalPrice,
    price: systemBasePrice,
    sum: baseSum,
    finalSum: finalSum,
    accessoriesTotal: accessoriesTotal,
    priceCalculation: {
      ...priceCalculation.result,
      totalAfterDiscount: finalSum,
      totalBeforeDiscount: baseSum,
      discountAmount: baseSum - finalSum
    },
    fabricLabel,
    width: currentItem.width,
    height: currentItem.height,
    roundedWidth: priceCalculation.result.roundedWidth,
    roundedHeight: priceCalculation.result.roundedHeight,
    dealer: dealerDisplayName,
    controlSide: currentItem.controlSide || '-',
    controlLength: currentItem.controlLength || '',
    mountingType: currentItem.mountingType || '',
    boxHeight: currentItem.boxHeight || '',
    chainType: '',
    additionalEquipment: '',
    add: accessoriesArray,
    accessoriesItems: accessoriesArray  
  };
  
  const updatedItems = [...currentOrder.items, newItem];
  setCurrentOrder(prev => ({ ...prev, items: updatedItems }));
  savePositionsToFile(updatedItems, currentOrder.orderNumber, currentOrder.dealer, currentOrder.notes, currentOrder.status);
  
  resetFormAfterEdit();
};
const updateItemInOrder = () => {
  const fabricLabel = currentItem.fabricCode;
  const dealerDisplayName = contractorName || dealerName || 'Дилер';
  let currentSystemType = currentItem.systemType;
  if (!currentSystemType && currentItem.systemName && categories) {
    const foundCategory = Object.entries(categories).find(([cat, sysList]) => sysList.includes(currentItem.systemName));
    if (foundCategory) currentSystemType = foundCategory[0];
  }
  
  
  const accessoriesTotal = accessoriesItems.reduce((sum, acc) => sum + (acc.price * acc.quantity), 0);
  
  
  const systemBasePrice = priceCalculation.result?.systemBasePrice || priceCalculation.result?.basePrice || currentItem.price || 0;
  
  const systemFinalPrice = priceCalculation.result?.systemFinalPrice || priceCalculation.result?.finalPrice || systemBasePrice;
  
  
  const baseSum = (systemBasePrice * currentItem.quantity) + accessoriesTotal;
  
  const finalSum = (systemFinalPrice * currentItem.quantity) + accessoriesTotal;
  
  const accessoriesArray = accessoriesItems.map(acc => ({
    name_add: acc.name,
    coloradd: currentItem.fabricColor || '',
    basePriceadd: acc.price.toString(),
    amountadd: acc.quantity.toString(),
    name: acc.name,
    price: acc.price,
    quantity: acc.quantity
  }));
  
  const updatedItem = {
    ...currentItem,
    systemType: currentSystemType,
    number: editingItemIndex + 1,
    quantity: currentItem.quantity,
    basePrice: systemBasePrice,
    finalPrice: systemFinalPrice,
    price: systemBasePrice,
    sum: baseSum,
    finalSum: finalSum,
    accessoriesTotal: accessoriesTotal,
    priceCalculation: {
      ...priceCalculation.result,
      systemBasePrice: systemBasePrice,
      systemFinalPrice: systemFinalPrice,
      basePrice: systemBasePrice,
      finalPrice: systemFinalPrice,
      totalBeforeDiscount: baseSum,
      totalAfterDiscount: finalSum,
      discountAmount: baseSum - finalSum
    },
    fabricLabel,
    width: currentItem.width,
    height: currentItem.height,
    roundedWidth: priceCalculation.result?.roundedWidth || currentItem.width,
    roundedHeight: priceCalculation.result?.roundedHeight || currentItem.height,
    dealer: dealerDisplayName,
    controlSide: currentItem.controlSide || '-',
    controlLength: currentItem.controlLength || '',
    mountingType: currentItem.mountingType || '',
    boxHeight: currentItem.boxHeight || '',
    chainType: '',
    additionalEquipment: '',
    add: accessoriesArray,
    accessoriesItems: accessoriesArray
  };
  
  const updatedItems = [...currentOrder.items];
  updatedItems[editingItemIndex] = updatedItem;
  setCurrentOrder(prev => ({ ...prev, items: updatedItems }));
  savePositionsToFile(updatedItems, currentOrder.orderNumber, currentOrder.dealer, currentOrder.notes, currentOrder.status);
  
  resetFormAfterEdit();
  setAccessoriesItems([]);
  setShowAccessoriesPanel(false);
};

 {}
<div className="form-group full-width" ref={systemTypeRef}>
  <label className="text-left">Тип системи<span className="required-star">*</span></label>
  <div className="system-combobox">
    <input 
      type="text" 
      className={`system-combobox-input ${validationErrors.systemType ? 'error' : ''}`} 
      value={systemTypeSearch} 
      onChange={handleSystemTypeSearchChange} 
      onFocus={handleSystemTypeFocus} 
      placeholder="Виберіть тип системи або почніть вводити..." 
      style={{ borderColor: validationErrors.systemType ? '#dc3545' : '' }}
    />
    <button type="button" className="system-combobox-btn" onClick={() => { 
      const systemTypes = Object.keys(categories); 
      setFilteredSystemTypes(systemTypes); 
      setShowSystemTypeDropdown(!showSystemTypeDropdown); 
    }}>▼</button>
    {showSystemTypeDropdown && filteredSystemTypes.length > 0 && (
      <div className="system-combobox-dropdown">
        {filteredSystemTypes.map(systemType => (
          <div key={systemType} className="system-combobox-item" onClick={() => handleSystemTypeSelect(systemType)}>
            {systemType}
          </div>
        ))}
      </div>
    )}
  </div>
  {validationErrors.systemType && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.systemType}</div>}
</div>

{}
<div className="form-group" ref={systemSearchRef}>
  <label className="text-left">Назва системи<span className="required-star">*</span></label>
  <div className="system-combobox">
    <input 
      type="text" 
      ref={systemInputRef} 
      className={`system-combobox-input ${validationErrors.systemName ? 'error' : ''}`} 
      value={systemSearch} 
      onChange={handleSystemSearchChange} 
      onFocus={handleSystemFocus} 
      placeholder="Виберіть систему або почніть вводити..." 
      style={{ borderColor: validationErrors.systemName ? '#dc3545' : '' }}
    />
    <button type="button" className="system-combobox-btn" onClick={() => { 
      let systemsToShow = []; 
      if (currentItem.systemType) { 
        systemsToShow = categories[currentItem.systemType] || []; 
      } else { 
        systemsToShow = systems; 
      } 
      setFilteredSystems(systemsToShow.filter(s => s !== currentItem.systemName)); 
      setShowSystemDropdown(!showSystemDropdown); 
    }}>▼</button>
    {showSystemDropdown && filteredSystems.length > 0 && (
      <div className="system-combobox-dropdown">
        {filteredSystems.map(system => (
          <div key={system} className="system-combobox-item" onClick={() => handleSystemSelect(system)}>
            {system}
          </div>
        ))}
      </div>
    )}
  </div>
  {validationErrors.systemName && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.systemName}</div>}
</div>

{}
<div className="form-group" ref={colorRef}>
  <label className="text-left">Колір системи<span className="required-star">*</span></label>
  <div className="system-combobox">
    <input 
      type="text" 
      className={`system-combobox-input ${validationErrors.fabricColor ? 'error' : ''}`} 
      value={availableColors.find(c => c.color === currentItem.fabricColor)?.color || ''} 
      onChange={(e) => { 
        const value = e.target.value; 
        const found = availableColors.find(c => c.color.toLowerCase().includes(value.toLowerCase())); 
        if (found) { 
          setCurrentItem(prev => ({ ...prev, fabricColor: found.color })); 
          setColorSearch(found.color); 
          setValidationErrors(prev => ({ ...prev, fabricColor: '' }));
        } else if (value === '') { 
          setCurrentItem(prev => ({ ...prev, fabricColor: '' })); 
          setColorSearch(''); 
        } 
      }} 
      onFocus={() => { 
        setFilteredColors(availableColors); 
        setShowColorDropdown(true); 
      }} 
      placeholder="Виберіть колір" 
      disabled={!currentItem.systemName || availableColors.length === 0}
      style={{ borderColor: validationErrors.fabricColor ? '#dc3545' : '' }}
    />
    <button type="button" className="system-combobox-btn" onClick={() => { 
      setFilteredColors(availableColors); 
      setShowColorDropdown(!showColorDropdown); 
    }} disabled={!currentItem.systemName || availableColors.length === 0}>▼</button>
    {showColorDropdown && filteredColors.length > 0 && (
      <div className="system-combobox-dropdown">
        {filteredColors.map((colorItem, idx) => (
          <div key={idx} className="system-combobox-item" onClick={() => { 
            setCurrentItem(prev => ({ ...prev, fabricColor: colorItem.color })); 
            setColorSearch(colorItem.color); 
            setShowColorDropdown(false); 
            setValidationErrors(prev => ({ ...prev, fabricColor: '' })); 
          }}>{colorItem.color}</div>
        ))}
      </div>
    )}
  </div>
  {validationErrors.fabricColor && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.fabricColor}</div>}
</div>

{}
<div className="form-group">
  <label className="text-left">Габаритна ширина (см)<span className="required-star">*</span></label>
  <input 
    type="number" 
    step="0.5" 
    min={systemParams?.widthRange.min || 0} 
    max={systemParams?.widthRange.max || 1000} 
    value={currentItem.width} 
    onChange={(e) => { 
      setCurrentItem(prev => ({ ...prev, width: e.target.value })); 
      setValidationErrors(prev => ({ ...prev, width: '' }));
    }} 
    disabled={!currentItem.systemName} 
    className={validationErrors.width || rangeErrors.width ? 'error' : ''} 
    style={{ borderColor: validationErrors.width || rangeErrors.width ? '#dc3545' : '' }}
  />
  {validationErrors.width && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.width}</div>}
  {systemParams && <div className="help-text range-help">Допустимий діапазон: {systemParams.widthRange.min} - {systemParams.widthRange.max} см</div>}
  {rangeErrors.width && <div className="range-error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>⚠️ Введено недопустимий діапазон</div>}
</div>

{}
{}
{}
<div className="form-group">
  <label className="text-left">Габаритна висота (см)<span className="required-star">*</span></label>
  <input 
    type="number" 
    step="0.5" 
    min="0.1" 
    max={systemParams ? Math.max(...systemParams.availableHeights) : 500} 
    value={currentItem.height} 
    onChange={(e) => { 
      setCurrentItem(prev => ({ ...prev, height: e.target.value })); 
      setValidationErrors(prev => ({ ...prev, height: '' }));
    }} 
    disabled={!currentItem.systemName} 
    className={validationErrors.height || rangeErrors.height ? 'error' : ''} 
    style={{ borderColor: validationErrors.height || rangeErrors.height ? '#dc3545' : '' }}
  />
  {validationErrors.height && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.height}</div>}
  {systemParams && (
    <div className="help-text range-help">
      Мінімальна доступна висота: {Math.min(...systemParams.availableHeights)} см
      {parseFloat(currentItem.height) > 0 && parseFloat(currentItem.height) < Math.min(...systemParams.availableHeights) && 
        ` (буде використано мінімальне значення ${Math.min(...systemParams.availableHeights)} см для розрахунку)`
      }
    </div>
  )}
  {rangeErrors.height && <div className="range-error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>⚠️ Висота має бути більше 0 см</div>}
</div>

{}
<div className="form-group">
  <label className="text-left">Кількість<span className="required-star">*</span></label>
  <input 
    type="number" 
    min="1" 
    max="100" 
    value={currentItem.quantity} 
    onChange={(e) => { 
      const qty = parseInt(e.target.value) || 1; 
      setCurrentItem(prev => ({ ...prev, quantity: qty, sum: prev.price * qty })); 
      setValidationErrors(prev => ({ ...prev, quantity: '' }));
    }} 
    disabled={!currentItem.systemName} 
    className={validationErrors.quantity ? 'error' : ''} 
    style={{ borderColor: validationErrors.quantity ? '#dc3545' : '' }}
  />
  {validationErrors.quantity && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.quantity}</div>}
</div>

{}
<div className="form-group" ref={controlSideRef}>
  <label className="text-left">Сторона управління<span className="required-star">*</span></label>
  <div className="system-combobox">
    <input 
      type="text" 
      className={`system-combobox-input ${validationErrors.controlSide ? 'error' : ''}`} 
      value={controlSideSearch} 
      onChange={handleControlSideSearchChange} 
      onFocus={handleControlSideFocus} 
      placeholder="Виберіть сторону"
      style={{ borderColor: validationErrors.controlSide ? '#dc3545' : '' }}
    />
    <button type="button" className="system-combobox-btn" onClick={() => { 
      setFilteredControlSides(controlSideOptions); 
      setShowControlSideDropdown(!showControlSideDropdown); 
    }}>▼</button>
    {showControlSideDropdown && filteredControlSides.length > 0 && (
      <div className="system-combobox-dropdown">
        {filteredControlSides.map(control => (
          <div key={control.value} className="system-combobox-item" onClick={() => handleControlSideSelect(control)}>
            {control.label}
          </div>
        ))}
      </div>
    )}
  </div>
  {validationErrors.controlSide && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.controlSide}</div>}
</div>

{}
{showMountingType && (
  <div className="form-row">
    <div className="form-group" ref={mountingTypeRef}>
      <label className="text-left">Тип монтажу<span className="required-star">*</span></label>
      <div className="system-combobox">
        <input 
          type="text" 
          className={`system-combobox-input ${validationErrors.mountingType ? 'error' : ''}`} 
          value={mountingSearch} 
          onChange={handleMountingSearchChange} 
          onFocus={handleMountingFocus} 
          placeholder="Виберіть тип монтажу або почніть вводити..."
          style={{ borderColor: validationErrors.mountingType ? '#dc3545' : '' }}
        />
        <button type="button" className="system-combobox-btn" onClick={() => { 
          setFilteredMountings(mountingTypes2); 
          setShowMountingDropdown(!showMountingDropdown); 
        }}>▼</button>
        {showMountingDropdown && filteredMountings.length > 0 && (
          <div className="system-combobox-dropdown">
            {filteredMountings.map(mounting => (
              <div key={mounting.value} className="system-combobox-item" onClick={() => handleMountingSelect(mounting)}>
                {mounting.label}
              </div>
            ))}
          </div>
        )}
      </div>
      {validationErrors.mountingType && <div className="error-message required-error" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.mountingType}</div>}
    </div>
  </div>
)}

{}
{showBoxHeight && (
  <div className="form-row">
    <div className="form-group">
      <label className="text-left">Висота між верхом короба та низом обтяжувача H1, см<span className="required-star">*</span></label>
      <input 
        type="number" 
        min="0" 
        step="0.5" 
        value={currentItem.boxHeight} 
        onChange={(e) => { 
          setCurrentItem(prev => ({ ...prev, boxHeight: e.target.value })); 
          setValidationErrors(prev => ({ ...prev, boxHeight: '' }));
        }} 
        placeholder="Введіть висоту" 
        className={validationErrors.boxHeight ? 'error' : ''} 
        style={{ borderColor: validationErrors.boxHeight ? '#dc3545' : '' }}
      />
      {validationErrors.boxHeight && <div className="error-message required-error" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.boxHeight}</div>}
    </div>
  </div>
)}
















  



  










      















        

















      


      










          




           
              











                



















const editItem = (index) => {
  const itemToEdit = currentOrder.items[index];
  if (!itemToEdit) return;
  
  console.log('=== РЕДАГУВАННЯ ПОЗИЦІЇ ===');
  console.log('Дані позиції:', itemToEdit);
  console.log('Додатки (add):', itemToEdit.add);
  
  let foundSystemType = itemToEdit.systemType || '';
  if (!foundSystemType && itemToEdit.systemName && categories) {
    const foundCategory = Object.entries(categories).find(([cat, sysList]) => sysList.includes(itemToEdit.systemName));
    if (foundCategory) foundSystemType = foundCategory[0];
  }
  
  
  const safeBasePrice = itemToEdit.basePrice || itemToEdit.price || 0;
  const safeFinalPrice = itemToEdit.finalPrice || (itemToEdit.priceCalculation?.finalPrice) || itemToEdit.price || 0;
  const safeQuantity = itemToEdit.quantity || 1;
  
  
  const loadedAccessories = [];
  
  
  if (itemToEdit.add && Array.isArray(itemToEdit.add) && itemToEdit.add.length > 0) {
    console.log('Завантаження додатків з item.add:', itemToEdit.add);
    for (let idx = 0; idx < itemToEdit.add.length; idx++) {
      const acc = itemToEdit.add[idx];
      const price = parseFloat(acc.basePriceadd) || parseFloat(acc.price) || 0;
      const qty = parseInt(acc.amountadd) || parseInt(acc.quantity) || 1;
      loadedAccessories.push({
        id: Date.now() + idx,
        name: acc.name_add || acc.name,
        quantity: qty,
        price: price,
        sum: price * qty
      });
    }
  }
  
  
  if (loadedAccessories.length === 0 && itemToEdit.accessoriesItems && Array.isArray(itemToEdit.accessoriesItems) && itemToEdit.accessoriesItems.length > 0) {
    console.log('Завантаження додатків з item.accessoriesItems:', itemToEdit.accessoriesItems);
    for (let idx = 0; idx < itemToEdit.accessoriesItems.length; idx++) {
      const acc = itemToEdit.accessoriesItems[idx];
      const price = parseFloat(acc.price) || parseFloat(acc.basePriceadd) || 0;
      const qty = parseInt(acc.quantity) || parseInt(acc.amountadd) || 1;
      loadedAccessories.push({
        id: Date.now() + idx,
        name: acc.name || acc.name_add,
        quantity: qty,
        price: price,
        sum: price * qty
      });
    }
  }
  
  console.log('Завантажено додатків:', loadedAccessories.length);
  console.log('Додатки:', loadedAccessories);
  
  const accessoriesTotal = loadedAccessories.reduce((sum, acc) => sum + (acc.price * acc.quantity), 0);
  
  
  const safeSum = itemToEdit.sum || ((safeBasePrice * safeQuantity) + accessoriesTotal);
  const safeFinalSum = itemToEdit.finalSum || ((safeFinalPrice * safeQuantity) + accessoriesTotal);
  
  
  setCurrentItem({
    number: index + 1,
    systemType: foundSystemType || '',
    systemName: itemToEdit.systemName || '',
    fabricCode: itemToEdit.fabricCode || '',
    fabricQuality: itemToEdit.fabricQuality || '',
    fabricColor: itemToEdit.fabricColor || '',
    width: itemToEdit.width || '',
    height: itemToEdit.height || '',
    boxHeight: itemToEdit.boxHeight || '',
    mountingType: itemToEdit.mountingType || '',
    controlSide: itemToEdit.controlSide === '-' ? '' : (itemToEdit.controlSide || ''),
    controlLength: itemToEdit.controlLength || '',
    quantity: safeQuantity,
    price: safeBasePrice,
    sum: safeSum,
    itemNotes: itemToEdit.itemNotes || ''
  });
  
  
  
  setAccessoriesItems([]);
  
  
  if (loadedAccessories.length > 0) {
    setTimeout(() => {
      setAccessoriesItems(loadedAccessories);
      setShowAccessoriesPanel(true);
    }, 100);
  } else {
    setShowAccessoriesPanel(false);
  }
  
  
  setSystemSearch(itemToEdit.systemName || '');
  setSystemTypeSearch(foundSystemType || '');
  const mountingLabel = mountingTypes2.find(m => m.value === itemToEdit.mountingType)?.label || '';
  setMountingSearch(mountingLabel);
  const controlSideLabel = controlSideOptions.find(c => c.value === itemToEdit.controlSide)?.label || '';
  setControlSideSearch(controlSideLabel);
  setColorSearch(itemToEdit.fabricColor || '');
  setEditingItemIndex(index);
  
  
  if (itemToEdit.priceCalculation) {
    setPriceCalculation({
      loading: false,
      result: {
        ...itemToEdit.priceCalculation,
        systemBasePrice: itemToEdit.priceCalculation.systemBasePrice || safeBasePrice,
        systemFinalPrice: itemToEdit.priceCalculation.systemFinalPrice || safeFinalPrice,
        basePrice: itemToEdit.priceCalculation.basePrice || safeBasePrice,
        finalPrice: itemToEdit.priceCalculation.finalPrice || safeFinalPrice,
        accessoriesTotal: accessoriesTotal,
        totalBeforeDiscount: itemToEdit.priceCalculation.totalBeforeDiscount || safeSum,
        totalAfterDiscount: itemToEdit.priceCalculation.totalAfterDiscount || safeFinalSum
      },
      error: null,
      warnings: []
    });
    setShowPriceResult(true);
  } else {
    setPriceCalculation({
      loading: false,
      result: {
        systemBasePrice: safeBasePrice,
        systemFinalPrice: safeFinalPrice,
        basePrice: safeBasePrice,
        finalPrice: safeFinalPrice,
        accessoriesTotal: accessoriesTotal,
        totalBeforeDiscount: safeSum,
        totalAfterDiscount: safeFinalSum
      },
      error: null,
      warnings: []
    });
    setShowPriceResult(true);
  }
  
  setRangeErrors({ width: false, height: false });
};
const removeItem = (index) => {
  showConfirm('Видалити цю позицію?', () => {
    const updatedItems = currentOrder.items.filter((_, i) => i !== index);
    setCurrentOrder(prev => ({ ...prev, items: updatedItems }));
    savePositionsToFile(updatedItems, currentOrder.orderNumber, currentOrder.dealer, currentOrder.notes, currentOrder.status);
  }, null, index);
};

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

const saveOrder = async (status = 'draft') => {
  try {
    const dealerDisplayName = contractorName || dealerName || 'Дилер';
    const orderToSave = {
      ...currentOrder,
      dealer: dealerDisplayName,
      userId,
      status,
      updatedAt: new Date().toISOString(),
      userEmail,
      userPhone,
      userToken,
      username: dealerName
    };
    if (!orderToSave.id) delete orderToSave.id;
    
    const response = await axios.post(`https://test2.planfix-to-syrve.com/api/save-order`, orderToSave);
    const data = response.data;
    
    if (data.success) {
      alert('Замовлення збережено!');
      setCurrentOrder(data.data);
      await fetchUserOrders();
      
      if (status === 'confirmed') {
        
        console.log('Очищення збережених позицій після оформлення...');
        await clearSavedPositions();
        
        
        
        
        
        const nextNum = nextOrderNumber + 1;
        setNextOrderNumber(nextNum);
        setCurrentOrder({
          id: null,
          dealer: dealerDisplayName,
          orderNumber: `ЗАМ-${nextNum.toString().padStart(3, '0')}`,
          date: new Date().toISOString().split('T')[0],
          items: [],
          notes: '',
          status: 'draft'
        });
        
        
        for (const draft of draftItems) {
          await deleteDraftItem(draft.id, false);
        }
        
        
        setIsRestoring(false);
        
        
        setShowOrderDraftsList(false);
        
        console.log('Всі збережені дані очищено (чернетки замовлень залишено)');
      }
    } else {
      alert('Помилка при збереженні: ' + data.error);
    }
  } catch (error) {
    console.error('Помилка збереження:', error);
    alert('Помилка при збереженні замовлення');
  }
};
  
  
  
  
  
  
  
  
const confirmOrder = () => {
  if (draftItems.length > 0) {
    showConfirm('У вас є незбережені чернетки позицій. Все одно оформити замовлення?', async () => {
      await saveOrder('confirmed');
      
      
      await axios.delete(`https://test2.planfix-to-syrve.com/api/clear-order-positions/${userId}`);
    });
  } else {
    showConfirm('Ви впевнені, що хочете оформити замовлення?', async () => {
      await saveOrder('confirmed');
      
      
      await axios.delete(`https://test2.planfix-to-syrve.com/api/clear-order-positions/${userId}`);
    });
  }
};
  const loadOrder = (order) => {
    if (order && order.id) {
      setCurrentOrder(order);
      setShowOrdersList(false);
    }
  };

  const showConfirm = (message, onConfirm, onCancel = null, itemIndex = null) => {
    setConfirmDialog({
      isOpen: true,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({ isOpen: false, message: '', onConfirm: null, onCancel: null, itemIndex: null });
      },
      onCancel: onCancel ? () => {
        onCancel();
        setConfirmDialog({ isOpen: false, message: '', onConfirm: null, onCancel: null, itemIndex: null });
      } : () => setConfirmDialog({ isOpen: false, message: '', onConfirm: null, onCancel: null, itemIndex: null }),
      itemIndex
    });
  };



  const recalculateItemPrice = async (item) => {
    try {
      const heightInMeters = parseFloat(item.height) / 100;
      const response = await axios.post(`https://test2.planfix-to-syrve.com/api/calculate-price`, {
        systemName: item.systemName,
        height: heightInMeters,
        width: parseInt(item.width),
        quality: item.fabricQuality,
        color: item.fabricColor,
        userId: userId
      });
      const data = response.data;
      if (data.success) {
        return { ...item, price: data.data.basePrice, sum: data.data.finalPrice, priceCalculation: data.data };
      }
      return item;
    } catch (error) {
      console.error('Помилка перерахунку ціни:', error);
      return item;
    }
  };

  const totalSum = currentOrder.items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const discountAmount = totalSum * (userDiscount / 100);
  const totalWithDiscount = totalSum - discountAmount;

  const canAddItem = priceCalculation.result && !priceCalculation.loading && 
    !rangeErrors.width && !rangeErrors.height &&
    currentItem.systemName && currentItem.fabricCode && 
    currentItem.fabricColor && currentItem.width && currentItem.height &&
    currentItem.controlSide &&
    (!showMountingType || (showMountingType && currentItem.mountingType)) &&
    (!showBoxHeight || (showBoxHeight && currentItem.boxHeight && parseFloat(currentItem.boxHeight) > 0));

  const canSaveDraft = currentItem.systemName || currentItem.fabricCode || currentItem.fabricColor || 
    currentItem.width || currentItem.height || currentItem.itemNotes;

  const dealerDisplayName = contractorName || dealerName || 'Завантаження...';

const OrderItemCard = ({ 
  index, 
  item, 
  fabricLabel, 
  displayPrice,
  convertedDisplayPrice,
  quantity, 
  accessoriesList, 
  convertedAccessoriesList,
  itemAccessoriesTotal,
  convertedAccessoriesTotal,
  baseSumInEuro,
  convertedBaseSum,
  editingItemIndex, 
  onEdit, 
  onRemove,
  onCopy,  
  getCurrencySymbol
}) => {
  const [showAccessoriesDetails, setShowAccessoriesDetails] = React.useState(false);
  const currencySymbol = getCurrencySymbol ? getCurrencySymbol() : '€';
  
  const firstTwoAccessories = accessoriesList.slice(0, 2);
  const remainingAccessories = accessoriesList.slice(2);
  
  return (
    <div className={`order-item-card ${editingItemIndex === index ? 'editing' : ''}`}>
      <div className="item-header">
        <span className="item-number">#{index + 1}</span>
        <span className="item-system">{item.systemName || '?'}{item.fabricColor ? `, ${item.fabricColor}` : ''}</span>
        <div className="item-actions">
          <button className="item-edit-btn" onClick={() => onEdit(index)} title="Редагувати">✏️</button>
          <button className="item-edit-btn" onClick={() => onCopy(index)} title="Копіювати">📋</button>
          <button className="item-remove-btn" onClick={() => onRemove(index)} title="Видалити">✕</button>
        </div>
      </div>
      
      <div className="item-details">
        <div className="item-details-left">
          <div className="item-detail">
            <span className="detail-label">Код тканини</span>
            <span className="detail-value">{fabricLabel}</span>
          </div>
          <div className="item-detail">
            <span className="detail-label">Розміри</span>
            <span className="detail-value">{item.width || '-'} x {item.height || '-'} см</span>
          </div>
          <div className="item-detail">
            <span className="detail-label">Кількість</span>
            <span className="detail-value">{quantity} шт.</span>
          </div>
        </div>
        
        <div className="item-details-right">
          <div className="item-detail price">
            <span className="detail-label">Ціна за од.</span>
            <span className="detail-value">{convertedDisplayPrice.toFixed(2)} {currencySymbol}</span>
          </div>
          {itemAccessoriesTotal > 0 && (
            <div className="item-detail accessories-price">
              <span className="detail-label">Вартість дод.</span>
              <span className="detail-value">{convertedAccessoriesTotal.toFixed(2)} {currencySymbol}</span>
            </div>
          )}
          <div className="item-detail sum">
            <span className="detail-label">Сума</span>
            <span className="detail-value">{convertedBaseSum.toFixed(2)} {currencySymbol}</span>
          </div>
        </div>
      </div>
      
      {item.itemNotes && <div className="item-notes">{item.itemNotes}</div>}
      
      {accessoriesList.length > 0 && (
        <div className="accessories-toggle-section">
          <button 
            className="accessories-details-btn"
            onClick={() => setShowAccessoriesDetails(!showAccessoriesDetails)}
          >
            {showAccessoriesDetails ? '▲ Додатково' : '▼ Додатково'}
          </button>
          
          {showAccessoriesDetails && (
            <div className="accessories-details-panel">
              <div className="accessories-two-columns">
                <div className="accessories-column">
                  {firstTwoAccessories.map((acc, accIdx) => {
                    const convertedAcc = convertedAccessoriesList[accIdx];
                    return (
                      <div key={accIdx} className="accessories-details-row">
                        <span className="accessory-name">{acc.name}</span>
                        <span className="accessory-quantity">{acc.quantity} шт.</span>
                        <span className="accessory-price">{convertedAcc?.convertedPrice?.toFixed(2) || 0} {currencySymbol}</span>
                      </div>
                    );
                  })}
                </div>
                
                {remainingAccessories.length > 0 && (
                  <div className="accessories-column">
                    {remainingAccessories.map((acc, accIdx) => {
                      const convertedAcc = convertedAccessoriesList[accIdx + 2];
                      return (
                        <div key={accIdx} className="accessories-details-row">
                          <span className="accessory-name">{acc.name}</span>
                          <span className="accessory-quantity">{acc.quantity} шт.</span>
                          <span className="accessory-price">{convertedAcc?.convertedPrice?.toFixed(2) || 0} {currencySymbol}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
  return (
    <div className="order-page" style={{ marginTop: "20px" }}>
      {authError && <div className="auth-error">⚠️ {authError}</div>}
      
      <ConfirmDialog 
        isOpen={confirmDialog.isOpen}
        message={confirmDialog.message}
        onConfirm={confirmDialog.onConfirm}
        onCancel={confirmDialog.onCancel}
      />

      {showFabricModal && (
        <div className="fabric-modal-overlay" onClick={closeFabricModal}>
          <div className="fabric-modal" onClick={(e) => e.stopPropagation()}>
            <div className="fabric-modal-header">
              <h2>Вибір тканини</h2>
              <button className="close-btn" onClick={closeFabricModal}>✕</button>
            </div>
            <div className="fabric-search">
              <input type="text" placeholder="Пошук за кодом або назвою..." value={fabricSearch} onChange={handleFabricSearch} autoFocus />
            </div>
            <div className="fabric-grid-container">
              {loadingFabrics ? (
                <div className="loading-fabrics">Завантаження...</div>
              ) : (
                <div className="fabric-grid">
                  {filteredFabrics.map(fabric => (
                    <div key={fabric.code} className={`fabric-item ${selectedFabric?.code === fabric.code ? 'selected' : ''}`} onClick={() => selectFabric(fabric)}>
                      <div className="fabric-image">
                        {fabric.imagePath ? (
                          <img src={`https://test2.planfix-to-syrve.com${fabric.imagePath}`} alt={fabric.code} onError={(e) => {
                            e.target.onerror = null;
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML = '<div class="no-image">Немає фото</div>';
                          }} />
                        ) : <div className="no-image">Немає фото</div>}
                      </div>
                      <div className="fabric-info">
                        <div className="fabric-code">{fabric.code}</div>
                        {fabric.priceGroup && <div className="fabric-price-group"></div>}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="fabric-modal-footer">
              <button className="cancel-btn" onClick={closeFabricModal}>Скасувати</button>
              <button className="confirm-btn" onClick={confirmFabricSelection} disabled={!selectedFabric}>Вибрати</button>
            </div>
          </div>
        </div>
      )}

      {showOrdersList && (
        <div className="orders-list-modal">
          <h2>Мої замовлення</h2>
          {orders.length === 0 ? (
            <p className="no-orders">У вас ще немає збережених замовлень</p>
          ) : (
            <div className="orders-grid">
              {orders.map(order => (
                <div key={order.id} className={`order-card ${order.status}`}>
                  <div className="order-card-header">
                    <span className="order-number">{order.orderNumber}</span>
                    <span className={`order-status ${order.status}`}>
                      {order.status === 'draft' ? 'Чернетка' : order.status === 'confirmed' ? 'Підтверджено' : 'Архів'}
                    </span>
                  </div>
                  <div className="order-card-body">
                    <div>Дата: {new Date(order.date).toLocaleDateString('uk-UA')}</div>
                    <div>Дилер: <strong>{order.dealer || 'Не вказано'}</strong></div>
                    <div>Позицій: {order.items.length}</div>
                    <div>Сума: {order.items.reduce((s, i) => s + i.sum, 0).toFixed(1)} €</div>
                  </div>
                  <div className="order-card-actions">
                    <button onClick={() => loadOrder(order)}>Відкрити</button>
                    <button onClick={() => repeatOrder(order)} className="repeat-btn">Повторити</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
{}
<div style={{ 
  display: 'flex', 
  justifyContent: 'space-between', 
  alignItems: 'center',
  marginBottom: '15px',
  padding: '10px 15px',
  backgroundColor: '#f8f9fa',
  borderRadius: '8px',
  border: '1px solid #e0e0e0'
}}>

  
  <div style={{ display: 'flex', gap: '10px' }}>
    <button
      onClick={() => {
        setShowOrderDraftsList(!showOrderDraftsList);
        if (!showOrderDraftsList) fetchOrderDrafts();
      }}
      style={{
        padding: '8px 16px',
        backgroundColor: '#6c757d',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        gap: '5px'
      }}
    >
      Чернетки {orderDrafts.length > 0 && `(${orderDrafts.length})`}
    </button>
  </div>
</div>

{}
{}
{showOrderDraftsList && (
  <div className="orders-list-modal" style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  }}>
    <div style={{
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '30px',
      maxWidth: '700px',
      width: '90%',
      maxHeight: '80vh',
      overflow: 'auto'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        borderBottom: '2px solid #f0f0f0',
        paddingBottom: '15px'
      }}>
        <h2 style={{ margin: 0 }}>Збережені чернетки замовлень</h2>
        <button
          onClick={() => setShowOrderDraftsList(false)}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666'
          }}
        >
          ✕
        </button>
      </div>

      {loadingOrderDrafts ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>Завантаження...</div>
      ) : orderDrafts.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
          <p>Немає збережених чернеток замовлень</p>
          <p style={{ fontSize: '14px', color: '#999' }}>
            Додайте позиції та натисніть "Зберегти як чернетку"
          </p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {orderDrafts.map((draft) => {
            const itemsCount = draft.items?.length || 0;
            const totalSum = (draft.items || []).reduce((sum, item) => {
              const price = item.finalPrice || item.price || 0;
              const qty = item.quantity || 1;
              return sum + (price * qty);
            }, 0);
            
            return (
              <div key={draft.draftId} style={{
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '15px',
                backgroundColor: '#fafafa'
              }}>
                {}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start'
                }}>
                  {}
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: '600', fontSize: '16px' }}>
                      {draft.draftNumber || draft.orderNumber || 'Чернетка'}
                    </div>
                    <div style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>
                      <div>{new Date(draft.savedAt || draft.createdAt).toLocaleString('uk-UA')}</div>
                      <div>{draft.dealer || 'Дилер'}</div>
                      <div>Позицій: {itemsCount}</div>
                      <div>Сума: {totalSum.toFixed(2)} €</div>
                    </div>
                  </div>
                  
                  {}
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    flexShrink: 0,
                    marginLeft: '15px',
                    alignItems: 'flex-end',
                    gap: '6px'
                  }}>
                    {}
                    <div style={{ 
                      display: 'flex', 
                      gap: '8px'
                    }}>
                      <button
                        onClick={() => useOrderDraft(draft.draftId)}
                        style={{
                          padding: '6px 14px',
                          backgroundColor: '#edec5b',
                          color: 'black',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '13px',
                          fontWeight: '500'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#d4d34a'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#edec5b'}
                      >
                        Використати
                      </button>
                      <button
                        onClick={() => deleteOrderDraft(draft.draftId)}
                        style={{
                          padding: '6px 14px',
                          backgroundColor: '#dc3545',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '13px',
                          fontWeight: '500'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
                      >
                        Видалити
                      </button>
                    </div>
                    
                    {}
                    <div style={{ 
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end',
                      gap: '2px'
                    }}>
                      {}
                      {draft.notes && draft.notes.trim() && (
                        <div style={{ 
                          padding: '3px 8px', 
                          backgroundColor: '#fff3cd', 
                          borderRadius: '4px',
                          fontSize: '11px',
                          color: '#856404',
                          maxWidth: '250px',
                          textAlign: 'right',
                          wordWrap: 'break-word'
                        }}>
                          <strong>Примітки до замовлення:</strong> {draft.notes}
                        </div>
                      )}
                      
                      {}
                      {draft.items && draft.items.some(item => item.itemNotes && item.itemNotes.trim()) && (
                        <>
                          {draft.items.map((item, idx) => {
                            if (item.itemNotes && item.itemNotes.trim()) {
                              return (
                                <div key={idx} style={{ 
                                  padding: '3px 8px', 
                                  backgroundColor: '#e8f4fd', 
                                  borderRadius: '4px',
                                  fontSize: '11px',
                                  color: '#0c5460',
                                  maxWidth: '250px',
                                  textAlign: 'right',
                                  wordWrap: 'break-word'
                                }}>
                                  <strong>Позиція #{idx + 1}:</strong> {item.itemNotes}
                                </div>
                              );
                            }
                            return null;
                          })}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      
      <div style={{
        marginTop: '20px',
        borderTop: '1px solid #f0f0f0',
        paddingTop: '15px',
        display: 'flex',
        justifyContent: 'flex-end'
      }}>
        <button
          onClick={() => setShowOrderDraftsList(false)}
          style={{
            padding: '8px 20px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Закрити
        </button>
      </div>
    </div>
  </div>
)}

{}
{}

<div className="order-content">
  <div className="left-column">
    <div className="form-section">
      <h3>{editingItemIndex !== null ? 'Редагувати позицію' : 'Додати позицію'}</h3>
      <div className="item-form">
        <div className="form-row">
          <div className="form-group full-width" ref={systemTypeRef}>
            <label className="text-left">Тип системи<span className="required-star">*</span></label>
            <div className="system-combobox">
              <input 
                type="text" 
                className={`system-combobox-input ${validationErrors.systemType ? 'error' : ''}`} 
                value={systemTypeSearch} 
                onChange={handleSystemTypeSearchChange} 
                onFocus={handleSystemTypeFocus} 
                placeholder="Виберіть тип системи або почніть вводити..."
                style={{ borderColor: validationErrors.systemType ? '#dc3545' : '' }}
              />
              <button type="button" className="system-combobox-btn" onClick={() => { const systemTypes = Object.keys(categories); setFilteredSystemTypes(systemTypes); setShowSystemTypeDropdown(!showSystemTypeDropdown); }}>▼</button>
              {showSystemTypeDropdown && filteredSystemTypes.length > 0 && (
                <div className="system-combobox-dropdown">
                  {filteredSystemTypes.map(systemType => (<div key={systemType} className="system-combobox-item" onClick={() => handleSystemTypeSelect(systemType)}>{systemType}</div>))}
                </div>
              )}
            </div>
            {validationErrors.systemType && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.systemType}</div>}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group" ref={systemSearchRef}>
            <label className="text-left">Назва системи<span className="required-star">*</span></label>
            <div className="system-combobox">
              <input 
                type="text" 
                ref={systemInputRef} 
                className={`system-combobox-input ${validationErrors.systemName ? 'error' : ''}`} 
                value={systemSearch} 
                onChange={handleSystemSearchChange} 
                onFocus={handleSystemFocus} 
                placeholder="Виберіть систему або почніть вводити..."
                style={{ borderColor: validationErrors.systemName ? '#dc3545' : '' }}
              />
              <button type="button" className="system-combobox-btn" onClick={() => { let systemsToShow = []; if (currentItem.systemType) { systemsToShow = categories[currentItem.systemType] || []; } else { systemsToShow = systems; } setFilteredSystems(systemsToShow.filter(s => s !== currentItem.systemName)); setShowSystemDropdown(!showSystemDropdown); }}>▼</button>
              {showSystemDropdown && filteredSystems.length > 0 && (
                <div className="system-combobox-dropdown">
                  {filteredSystems.map(system => (<div key={system} className="system-combobox-item" onClick={() => handleSystemSelect(system)}>{system}</div>))}
                </div>
              )}
            </div>
            {validationErrors.systemName && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.systemName}</div>}
          </div>

          <div className="form-group" ref={colorRef}>
            <label className="text-left">Колір системи<span className="required-star">*</span></label>
            <div className="system-combobox">
              <input 
                type="text" 
                className={`system-combobox-input ${validationErrors.fabricColor ? 'error' : ''}`} 
                value={availableColors.find(c => c.color === currentItem.fabricColor)?.color || ''} 
                onChange={(e) => { 
                  const value = e.target.value; 
                  const found = availableColors.find(c => c.color.toLowerCase().includes(value.toLowerCase())); 
                  if (found) { 
                    setCurrentItem(prev => ({ ...prev, fabricColor: found.color })); 
                    setColorSearch(found.color); 
                    setValidationErrors(prev => ({ ...prev, fabricColor: '' }));
                  } else if (value === '') { 
                    setCurrentItem(prev => ({ ...prev, fabricColor: '' })); 
                    setColorSearch(''); 
                  } 
                }} 
                onFocus={() => { 
                  setFilteredColors(availableColors); 
                  setShowColorDropdown(true); 
                }} 
                placeholder="Виберіть колір" 
                disabled={!currentItem.systemName || availableColors.length === 0}
                style={{ borderColor: validationErrors.fabricColor ? '#dc3545' : '' }}
              />
              <button 
                type="button" 
                className="system-combobox-btn" 
                onClick={() => { setFilteredColors(availableColors); setShowColorDropdown(!showColorDropdown); }} 
                disabled={!currentItem.systemName || availableColors.length === 0}
              >▼</button>
              {showColorDropdown && filteredColors.length > 0 && (
                <div className="system-combobox-dropdown">
                  {filteredColors.map((colorItem, idx) => (<div key={idx} className="system-combobox-item" onClick={() => { setCurrentItem(prev => ({ ...prev, fabricColor: colorItem.color })); setColorSearch(colorItem.color); setShowColorDropdown(false); setValidationErrors(prev => ({ ...prev, fabricColor: '' })); }}>{colorItem.color}</div>))}
                </div>
              )}
            </div>
            {validationErrors.fabricColor && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.fabricColor}</div>}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group fabric-code-group">
            <label className="text-left">Код тканини<span className="required-star">*</span></label>
            <div className="fabric-code-input">
              <input 
                type="text" 
                value={currentItem.fabricCode} 
                readOnly 
                placeholder={currentItem.systemName ? "Виберіть код тканини" : "Спочатку виберіть систему"} 
                className={validationErrors.fabricCode ? 'error' : ''} 
                disabled={!currentItem.systemName}
                onClick={() => {
                  if (currentItem.systemName) {
                    openFabricModal();
                  }
                }}
                style={{ 
                  cursor: currentItem.systemName ? 'pointer' : 'not-allowed',
                  borderColor: validationErrors.fabricCode ? '#dc3545' : ''
                }}
              />
              <button 
                type="button" 
                className="fabric-select-btn" 
                onClick={openFabricModal} 
                disabled={!currentItem.systemName}
              >
                ⋯
              </button>
            </div>
            {validationErrors.fabricCode && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.fabricCode}</div>}
          </div>
        </div>

        <div className="form-row">
          {}
<div className="form-group">
  <label className="text-left">Габаритна ширина (см)<span className="required-star">*</span></label>
  <input 
    type="number" 
    step="0.5" 
    min={systemParams?.widthRange.min || 0} 
    max={systemParams?.widthRange.max || 1000} 
    value={currentItem.width} 
    onChange={(e) => { 
      const value = parseFloat(e.target.value);
      if (systemParams && value < systemParams.widthRange.min) {
        setRangeErrors(prev => ({ ...prev, width: true }));
      } else {
        setRangeErrors(prev => ({ ...prev, width: false }));
      }
      setCurrentItem(prev => ({ ...prev, width: e.target.value })); 
      setValidationErrors(prev => ({ ...prev, width: '' }));
    }} 
    disabled={!currentItem.systemName} 
    className={validationErrors.width || rangeErrors.width ? 'error' : ''} 
    style={{ borderColor: validationErrors.width || rangeErrors.width ? '#dc3545' : '' }}
  />
  {validationErrors.width && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.width}</div>}
  {systemParams && <div className="help-text range-help">Допустимий діапазон: {systemParams.widthRange.min} - {systemParams.widthRange.max} см</div>}
 
</div>

          <div className="form-group">
            <label className="text-left">Габаритна висота (см)<span className="required-star">*</span></label>
            <input 
              type="number" 
              step="0.5" 
              min={systemParams ? Math.min(...systemParams.availableHeights) : 10} 
              max={systemParams ? Math.max(...systemParams.availableHeights) : 500} 
              value={currentItem.height} 
              onChange={(e) => { 
                setCurrentItem(prev => ({ ...prev, height: e.target.value })); 
                setValidationErrors(prev => ({ ...prev, height: '' }));
              }} 
              disabled={!currentItem.systemName} 
              className={validationErrors.height || rangeErrors.height ? 'error' : ''} 
              style={{ borderColor: validationErrors.height || rangeErrors.height ? '#dc3545' : '' }}
            />
            {validationErrors.height && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.height}</div>}
            {systemParams && <div className="help-text range-help">Допустимий діапазон: {Math.min(...systemParams.availableHeights)} - {Math.max(...systemParams.availableHeights)} см</div>}
            {rangeErrors.height && <div className="range-error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>⚠️ Введено недопустимий діапазон</div>}
          </div>

          {}
<div className="form-group">
  <label className="text-left">Кількість<span className="required-star">*</span></label>
  <input 
    type="number" 
    min="1" 
    max="100" 
    value={currentItem.quantity === 0 ? '' : currentItem.quantity} 
    onChange={(e) => { 
      const value = e.target.value;
      
      if (value === '') {
        setCurrentItem(prev => ({ 
          ...prev, 
          quantity: '', 
          sum: 0
        })); 
        setValidationErrors(prev => ({ ...prev, quantity: '' }));
      } else {
        const qty = parseInt(value);
        if (!isNaN(qty)) {
          setCurrentItem(prev => ({ 
            ...prev, 
            quantity: qty, 
            sum: prev.price * qty
          })); 
          setValidationErrors(prev => ({ ...prev, quantity: '' }));
        }
      }
    }} 
    onBlur={(e) => {
      const value = e.target.value;
      
      if (value === '' || parseInt(value) < 1) {
        setCurrentItem(prev => ({ 
          ...prev, 
          quantity: 1, 
          sum: prev.price * 1
        }));
      }
    }}
    disabled={!currentItem.systemName} 
    className={validationErrors.quantity ? 'error' : ''} 
    style={{ borderColor: validationErrors.quantity ? '#dc3545' : '' }}
  />
  {validationErrors.quantity && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.quantity}</div>}
</div>
        </div>

        {showBoxHeight && (
          <div className="form-row">
            <div className="form-group">
              <label className="text-left">Висота між верхом короба та низом обтяжувача H1, см<span className="required-star">*</span></label>
              <input 
                type="number" 
                min="0" 
                step="0.5" 
                value={currentItem.boxHeight} 
                onChange={(e) => { 
                  setCurrentItem(prev => ({ ...prev, boxHeight: e.target.value })); 
                  setValidationErrors(prev => ({ ...prev, boxHeight: '' }));
                }} 
                placeholder="Введіть висоту" 
                className={validationErrors.boxHeight ? 'error' : ''} 
                style={{ borderColor: validationErrors.boxHeight ? '#dc3545' : '' }}
              />
              {validationErrors.boxHeight && <div className="error-message required-error" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.boxHeight}</div>}
            </div>
          </div>
        )}

        {showMountingType && (
          <div className="form-row">
            <div className="form-group" ref={mountingTypeRef}>
              <label className="text-left">Тип монтажу<span className="required-star">*</span></label>
              <div className="system-combobox">
                <input 
                  type="text" 
                  className={`system-combobox-input ${validationErrors.mountingType ? 'error' : ''}`} 
                  value={mountingSearch} 
                  onChange={handleMountingSearchChange} 
                  onFocus={handleMountingFocus} 
                  placeholder="Виберіть тип монтажу або почніть вводити..."
                  style={{ borderColor: validationErrors.mountingType ? '#dc3545' : '' }}
                />
                <button type="button" className="system-combobox-btn" onClick={() => { setFilteredMountings(mountingTypes2); setShowMountingDropdown(!showMountingDropdown); }}>▼</button>
                {showMountingDropdown && filteredMountings.length > 0 && (
                  <div className="system-combobox-dropdown">
                    {filteredMountings.map(mounting => (<div key={mounting.value} className="system-combobox-item" onClick={() => handleMountingSelect(mounting)}>{mounting.label}</div>))}
                  </div>
                )}
              </div>
              {validationErrors.mountingType && <div className="error-message required-error" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.mountingType}</div>}
            </div>
          </div>
        )}

        <div className="form-row">
          <div className="form-group" ref={controlSideRef}>
            <label className="text-left">Сторона управління<span className="required-star">*</span></label>
            <div className="system-combobox">
              <input 
                type="text" 
                className={`system-combobox-input ${validationErrors.controlSide ? 'error' : ''}`} 
                value={controlSideSearch} 
                onChange={handleControlSideSearchChange} 
                onFocus={handleControlSideFocus} 
                placeholder="Виберіть сторону"
                style={{ borderColor: validationErrors.controlSide ? '#dc3545' : '' }}
              />
              <button type="button" className="system-combobox-btn" onClick={() => { setFilteredControlSides(controlSideOptions); setShowControlSideDropdown(!showControlSideDropdown); }}>▼</button>
              {showControlSideDropdown && filteredControlSides.length > 0 && (
                <div className="system-combobox-dropdown">
                  {filteredControlSides.map(control => (<div key={control.value} className="system-combobox-item" onClick={() => handleControlSideSelect(control)}>{control.label}</div>))}
                </div>
              )}
            </div>
            {validationErrors.controlSide && <div className="error-message" style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>{validationErrors.controlSide}</div>}
          </div>

          <div className="form-group">
            <label className="text-left">Довжина управління (см) <span className="optional-star"></span></label>
            <input type="number" min="0" value={currentItem.controlLength} onChange={(e) => setCurrentItem(prev => ({ ...prev, controlLength: e.target.value }))} placeholder="0" />
          </div>
        </div>
{}
{}
<div className="form-group full-width">
<button 
  type="button" 
  className="accessories-toggle-btn" 
  onClick={() => {
    if (availableAccessories.length > 0) {
      setShowAccessoriesPanel(!showAccessoriesPanel);
    }
  }}
  disabled={!currentItem.systemName || availableAccessories.length === 0}
  style={{
    width: '100%',
    padding: '10px',
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: (currentItem.systemName && availableAccessories.length > 0) ? 'pointer' : 'not-allowed',
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'center',
    transition: 'all 0.2s',
    opacity: (!currentItem.systemName || availableAccessories.length === 0) ? 0.5 : 1
  }}
  onMouseEnter={(e) => {
    if (currentItem.systemName && availableAccessories.length > 0) {
      e.currentTarget.style.backgroundColor = '#5a6268';
    }
  }}
  onMouseLeave={(e) => {
    if (currentItem.systemName && availableAccessories.length > 0) {
      e.currentTarget.style.backgroundColor = '#6c757d';
    }
  }}
>
  {showAccessoriesPanel ? '▲ Сховати додаткові комплектуючі' : '▼ Показати додаткові комплектуючі'}
</button>
</div>

{showAccessoriesPanel && (
  <div className="accessories-panel" style={{
    backgroundColor: '#6c757d',
    borderRadius: '6px',
    padding: '10px',
    marginTop: '10px'
  }}>
    {}
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      padding: '8px 0',
      borderBottom: '2px solid rgba(255, 255, 255, 0.3)',
      marginBottom: '5px',
      fontWeight: 'bold',
      color: 'white',
      fontSize: '13px'
    }}>
      <div style={{ flex: 2, color: 'white' }}>Назва додатку</div>
      <div style={{ flex: 0.6, textAlign: 'center', color: 'white' }}>Кількість</div>
      <div style={{ flex: 0.8, textAlign: 'right', color: 'white' }}>Ціна</div>
      <div style={{ flex: 0.8, textAlign: 'right', color: 'white' }}>Сума</div>
      <div style={{ width: '30px' }}></div>
    </div>
    
    {}
    {accessoriesItems.map(acc => (
      <div key={acc.id} style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '8px 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
      }}>
        <div style={{ flex: 2 }}>
          <input 
            type="text"
            value={acc.name}
            readOnly
            style={{
              width: '100%',
              padding: '6px 8px',
              borderRadius: '4px',
              border: '1px solid #000000',
              backgroundColor: '#b5babd',
              fontSize: '13px',
              color: '#333',
              cursor: 'default'
            }}
          />
        </div>
        
        <div style={{ flex: 0.6 }}>
          <input 
            type="number" 
            min="1" 
            value={acc.quantity === 0 ? '' : acc.quantity}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '') {
                const updatedItems = accessoriesItems.map(item => {
                  if (item.id === acc.id) {
                    return { ...item, quantity: '', sum: 0 };
                  }
                  return item;
                });
                setAccessoriesItems(updatedItems);
              } else {
                const newQuantity = parseInt(value);
                if (!isNaN(newQuantity) && newQuantity >= 1) {
                  updateAccessoryQuantity(acc.id, newQuantity);
                }
              }
            }}
            onBlur={(e) => {
              const value = e.target.value;
              if (value === '' || parseInt(value) < 1) {
                updateAccessoryQuantity(acc.id, 1);
              }
            }}
            style={{
              width: '100%',
              padding: '6px 4px',
              borderRadius: '4px',
              border: '1px solid #000000',
              backgroundColor: '#b5babd',
              fontSize: '13px',
              textAlign: 'center',
              color: '#333'
            }}
          />
        </div>
        
        <div style={{ flex: 0.8, textAlign: 'right', fontSize: '13px', color: 'white' }}>
          {acc.price.toFixed(2)} €
        </div>
        <div style={{ flex: 0.8, textAlign: 'right', fontWeight: 600, fontSize: '13px', color: 'white' }}>
          {acc.sum.toFixed(2)} €
        </div>
        <button 
          onClick={() => removeAccessoryRow(acc.id)}
          style={{
            background: 'none',
            border: 'none',
            color: '#ff6b6b',
            fontSize: '16px',
            cursor: 'pointer',
            padding: '0 5px',
            width: '30px'
          }}
        >
          ✕
        </button>
      </div>
    ))}
    
    {}
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      padding: '8px 0',
      marginTop: accessoriesItems.length > 0 ? '15px' : '0'
    }}>
      <div style={{ flex: 2 }} ref={accessoryRef}>
        <div className="system-combobox" style={{ width: '100%' }}>
          <input 
            type="text"
            className="system-combobox-input"
            value={accessorySearch}
            onChange={(e) => {
              const value = e.target.value;
              setAccessorySearch(value);
              if (value.trim()) {
                const filtered = availableAccessories.filter(acc =>
                  acc.name.toLowerCase().includes(value.toLowerCase())
                );
                setFilteredAccessories(filtered);
                setShowAccessoryDropdown(filtered.length > 0);
              } else {
                setFilteredAccessories(availableAccessories);
                setShowAccessoryDropdown(availableAccessories.length > 0);
              }
            }}
            onFocus={() => {
              if (availableAccessories.length > 0) {
                setFilteredAccessories(availableAccessories);
                setShowAccessoryDropdown(true);
              }
            }}
            placeholder="Виберіть додаток"
            disabled={availableAccessories.length === 0}
            style={{ 
              fontSize: '13px',
              border: '1px solid #000000',
              backgroundColor: '#b5babd',
              color: '#333'
            }}
          />
          <button 
            type="button" 
            className="system-combobox-btn"
            onClick={() => {
              if (availableAccessories.length > 0) {
                setFilteredAccessories(availableAccessories);
                setShowAccessoryDropdown(!showAccessoryDropdown);
              }
            }}
            disabled={availableAccessories.length === 0}
            style={{
              backgroundColor: '#b5babd',
              border: 'none',
              color: '#333'
            }}
          >
            ▼
          </button>
          {showAccessoryDropdown && filteredAccessories.length > 0 && (
            <div className="system-combobox-dropdown">
              {filteredAccessories.map((acc, idx) => (
                <div 
                  key={idx} 
                  className="system-combobox-item"
                  onClick={() => {
                    setNewAccessory({
                      name: acc.name,
                      quantity: 1,
                      price: acc.price,
                      sum: acc.price,
                      quantityError: false
                    });
                    setAccessorySearch(acc.name);
                    setShowAccessoryDropdown(false);
                  }}
                >
                  {acc.name} {acc.price > 0 && `(${acc.price.toFixed(2)} €)`}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      
      <div style={{ flex: 0.6 }}>
        <input 
          type="number"
          min="1"
          value={newAccessory.quantity === 0 ? '' : newAccessory.quantity}
          onChange={(e) => {
            const value = e.target.value;
            if (value === '') {
              setNewAccessory(prev => ({ 
                ...prev, 
                quantity: '',
                quantityError: false,
                sum: 0
              }));
            } else {
              const qty = parseInt(value);
              if (!isNaN(qty) && qty >= 0) {
                setNewAccessory(prev => ({ 
                  ...prev, 
                  quantity: qty,
                  quantityError: false,
                  sum: prev.price * qty
                }));
              }
            }
          }}
          onBlur={(e) => {
            const value = e.target.value;
            if (value === '' || parseInt(value) < 1) {
              setNewAccessory(prev => ({ 
                ...prev, 
                  quantity: 1,
                  quantityError: false,
                sum: prev.price * 1
              }));
            }
          }}
          style={{
            width: '100%',
            padding: '6px 4px',
            borderRadius: '4px',
            border: newAccessory.quantityError ? '2px solid #dc3545' : '1px solid #000000',
            backgroundColor: '#b5babd',
            fontSize: '13px',
            textAlign: 'center',
            color: '#333'
          }}
        />
      </div>
      
      <div style={{ flex: 0.8, textAlign: 'right', fontSize: '13px', color: 'white' }}>
        {newAccessory.price.toFixed(2)} €
      </div>
      
      <div style={{ flex: 0.8, textAlign: 'right', fontSize: '13px', fontWeight: 'normal', color: 'white' }}>
        {newAccessory.sum.toFixed(2)} €
      </div>
      
      <button 
        onClick={() => {
          if (!newAccessory.name) {
            alert('Виберіть додаток');
            return;
          }
          
          if (!newAccessory.quantity || newAccessory.quantity < 1) {
            setNewAccessory(prev => ({ ...prev, quantityError: true }));
            return;
          }
          
          const newItem = {
            id: Date.now(),
            name: newAccessory.name,
            quantity: newAccessory.quantity,
            price: newAccessory.price,
            sum: newAccessory.price * newAccessory.quantity
          };
          setAccessoriesItems([...accessoriesItems, newItem]);
          
          setNewAccessory({
            name: '',
            quantity: 1,
            price: 0,
            sum: 0,
            quantityError: false
          });
          setAccessorySearch('');
          setFilteredAccessories([]);
          setShowAccessoryDropdown(false);
        }}
        style={{
          background: 'rgba(255, 255, 255, 0.2)',
          border: 'none',
          color: 'white',
          fontSize: '20px',
          cursor: 'pointer',
          padding: '0 5px',
          width: '30px',
          fontWeight: 'bold',
          borderRadius: '4px'
        }}
      >
        +
      </button>
    </div>
    
    {loadingAccessories && (
      <div className="price-loading" style={{ marginTop: '10px', fontSize: '12px', color: 'white' }}>
        Завантаження...
      </div>
    )}
    
    {availableAccessories.length === 0 && !loadingAccessories && currentItem.systemName && (
      <div className="help-text" style={{ marginTop: '10px', textAlign: 'center', fontSize: '12px', color: 'white' }}>
        Немає доступних додатків
      </div>
    )}
  </div>
)}
        <div className="form-row">
          <div className="form-group full-width">
            <label className="text-left">Примітки до позиції <span className="optional-star"></span></label>
            <textarea value={currentItem.itemNotes} onChange={(e) => setCurrentItem(prev => ({ ...prev, itemNotes: e.target.value }))} placeholder="Додаткові примітки до цієї позиції..." rows="2" />
          </div>
        </div>

        {priceCalculation.loading && <div className="price-loading">🔄 Розрахунок ціни...</div>}
        {priceCalculation.error && <div className="price-error" style={{ color: '#dc3545', fontSize: '14px', marginTop: '10px' }}>❌ {priceCalculation.error}</div>}

        <div className="form-actions">
          <button 
            className="add-item-btn" 
            onClick={addItemToOrderWithConfirm}
          >
            {editingItemIndex !== null ? 'Оновити позицію' : 'Додати до замовлення'}
          </button>
          <button className="save-draft-item-btn" onClick={saveAsDraft} disabled={!canSaveDraft}>Зберегти чернетку</button>
          {editingItemIndex !== null && (
  <button 
    className="cancel-edit-btn" 
    onClick={() => {
      resetFormAfterEdit();
    }}
  >
    ✕ Скасувати
  </button>
)}
        </div>
      </div>
    </div>
  </div>

  <div className="right-column">
    <div className="order-info-card">
      <div className="order-number-header"><h2>Замовлення № {currentOrder.orderNumber}</h2></div>
      {}
<div className="currency-switcher" style={{ 
  display: 'flex', 
  justifyContent: 'center',  
  alignItems: 'center', 
  gap: '10px',
  marginBottom: '15px',
  padding: '8px',
  backgroundColor: '#f0f0f0',
  borderRadius: '8px'
}}>
  <span style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>Валюта:</span>
  <div style={{ 
    display: 'flex', 
    gap: '5px',
    backgroundColor: '#fff',
    borderRadius: '6px',
    padding: '3px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
  }}>
    <button
      onClick={() => setCurrency('EUR')}
      style={{
        padding: '6px 15px',
        backgroundColor: currency === 'EUR' ? '#edec5b' : '#f5f5f5',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: currency === 'EUR' ? '600' : '400',
        color: currency === 'EUR' ? '#333' : '#666',
        transition: 'all 0.2s'
      }}
    >
      EUR €
    </button>
    <button
      onClick={() => setCurrency('UAH')}
      style={{
        padding: '6px 15px',
        backgroundColor: currency === 'UAH' ? '#edec5b' : '#f5f5f5',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: currency === 'UAH' ? '600' : '400',
        color: currency === 'UAH' ? '#333' : '#666',
        transition: 'all 0.2s'
      }}
    >
      UAH ₴
    </button>
  </div>
  {currency === 'UAH' && !loadingRate && (
    <span style={{ fontSize: '12px', color: '#666', marginLeft: '5px' }}>
     
    </span>
  )}
  {loadingRate && <span style={{ fontSize: '12px', color: '#999' }}>Завантаження курсу...</span>}
</div>
{showPriceResult && priceCalculation.result && (
  <div className="current-price-result">
    <h3>Розрахунок поточної позиції</h3>
    

    
    <div className="current-item-info">
      <div className="info-row">
        <span className="info-label">Система:</span>
        <span className="info-value">{currentItem.systemName}{currentItem.fabricColor ? `, ${currentItem.fabricColor}` : ''}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Код тканини:</span>
        <span className="info-value">{currentItem.fabricCode}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Розміри:</span>
        <span className="info-value">{currentItem.width} x {currentItem.height} см</span>
      </div>
      <div className="info-row">
        <span className="info-label">Кількість:</span>
        <span className="info-value">{currentItem.quantity} шт.</span>
      </div>
      <div className="info-row">
        <span className="info-label">Сторона управління:</span>
        <span className="info-value">{currentItem.controlSide === 'left' ? 'Ліва' : 'Права'}</span>
      </div>
    </div>
    <div className="price-calculation">
  {}
  <div className="summary-row">
    <span>Ціна за од.</span>
    <span className="price-value">
      {convertPrice(priceCalculation.result.systemBasePrice || priceCalculation.result.basePrice || 0).toFixed(2)} {getCurrencySymbol()}
    </span>
  </div>
  
  {}
  <div className="summary-row accessories">
    <span>Вартість дод.</span>
    <span>{convertPrice(priceCalculation.result.accessoriesTotal || 0).toFixed(2)} {getCurrencySymbol()}</span>
  </div>
  
  {}
  <div className="summary-row subtotal">
    <span>Сума без знижки</span>
    <span>{convertPrice(priceCalculation.result.totalBeforeDiscount || 0).toFixed(2)} {getCurrencySymbol()}</span>
  </div>
  
  {}
  {priceCalculation.result.marevoDiscountAmount > 0 && (
    <div className="summary-row marevo-discount">
      <span>Знижка Марево</span>
      <span>-{convertPrice(priceCalculation.result.marevoDiscountAmount).toFixed(2)} {getCurrencySymbol()}</span>
    </div>
  )}
  
  {}
  {priceCalculation.result.dealerDiscountAmount > 0 && (
    <div className="summary-row dealer-discount">
      <span>Знижка дилера</span>
      <span>-{convertPrice(priceCalculation.result.dealerDiscountAmount).toFixed(2)} {getCurrencySymbol()}</span>
    </div>
  )}
  
  {}
  {priceCalculation.result.fabricDiscountAmount > 0 && (
    <div className="summary-row fabric-discount">
      <span>Знижка на тканину</span>
      <span>-{convertPrice(priceCalculation.result.fabricDiscountAmount).toFixed(2)} {getCurrencySymbol()}</span>
    </div>
  )}
  
  {}
  <div className="summary-row online-discount">
    <span>Знижка за замовлення онлайн</span>
    <span>-{convertPrice(priceCalculation.result.onlineDiscountAmount || 0).toFixed(2)} {getCurrencySymbol()}</span>
  </div>
  
  {}
  <div className="summary-row total">
    <span>Сума зі знижкою</span>
    <span className="price-value">
      {convertPrice(priceCalculation.result.totalAfterDiscount || priceCalculation.result.finalPrice || 0).toFixed(2)} {getCurrencySymbol()}
    </span>
  </div>
</div>
  </div>
)}

     {}
{draftItems.length > 0 && (
  <div className="draft-items-list">
    <h3>Чернетки позицій</h3>
    <div className="draft-items-container">
      {loadingDrafts ? <div className="loading-drafts">Завантаження чернеток...</div> : draftItems.map((draft, idx) => {
        const hasValidDimensions = draft.width && draft.height && draft.width !== '' && draft.height !== '' && parseFloat(draft.width) > 0 && parseFloat(draft.height) > 0;
        const draftPrice = hasValidDimensions ? (draft.price || 0) : 0;
        const draftQuantity = hasValidDimensions ? (draft.quantity || 1) : 1;
        const draftSum = draftPrice * draftQuantity;
        const widthValue = draft.width && draft.width !== '' ? draft.width : '-';
        const heightValue = draft.height && draft.height !== '' ? draft.height : '-';
        const dimensionsText = `${widthValue} x ${heightValue} см`;
        return (
          <div key={draft.id} className="order-item-card draft-item-card">
            <div className="item-header draft-item-header">
              <span className="item-number draft-number">Чернетка #{idx + 1}</span>
              <span className="item-system draft-system">{draft.systemName || 'Не вибрано'}{draft.fabricColor ? `, ${draft.fabricColor}` : ''}</span>
              <div className="item-actions draft-actions">
                <button className="item-edit-btn draft-edit-btn" onClick={() => editDraftItem(draft)} title="Редагувати">✏️</button>
                <button className="item-remove-btn draft-remove-btn" onClick={() => deleteDraftItem(draft.id)} title="Видалити">✕</button>
              </div>
            </div>
            <div className="item-details draft-details">
              <div className="item-details-left">
                <div className="item-detail draft-detail"><span className="detail-label">Код тканини</span><span className="detail-value">{draft.fabricCode || '-'}</span></div>
                <div className="item-detail draft-detail"><span className="detail-label">Розміри</span><span className="detail-value">{dimensionsText}</span></div>
                <div className="item-detail draft-detail"><span className="detail-label">Кількість</span><span className="detail-value">{draft.quantity || 1} шт.</span></div>
              </div>
              <div className="item-details-right">
                <div className="item-detail draft-detail price"><span className="detail-label">Ціна за од.</span><span className="detail-value">{hasValidDimensions && draftPrice > 0 ? `${draftPrice.toFixed(1)} €` : '-'}</span></div>
                <div className="item-detail draft-detail sum"><span className="detail-label">Сума</span><span className="detail-value">{hasValidDimensions && draftSum > 0 ? `${draftSum.toFixed(1)} €` : '-'}</span></div>
              </div>
            </div>
            {}
            {draft.itemNotes && <div className="item-notes draft-notes" style={{
              marginTop: '8px',
              padding: '6px 12px',
              backgroundColor: '#fff3cd',
              borderRadius: '4px',
              borderLeft: '3px solid #ffc107',
              fontSize: '12px',
              color: '#856404'
            }}>📝 {draft.itemNotes}</div>}
          </div>
        );
      })}
    </div>
  </div>
)}

<div className="order-items-list">
  <h3>Позиції замовлення</h3>
  {currentOrder.items.length === 0 ? <p className="no-items">Немає доданих позицій</p> : (
    <div className="items-container">
      {currentOrder.items.map((item, index) => {
        
        const fabricLabel = item.fabricCode || '-';
        const displayPrice = (item.basePrice || item.price || 0);
        const quantity = item.quantity || 1;
        
        
        let itemAccessoriesTotal = 0;
        let accessoriesList = [];
        
        if (item.add && item.add.length > 0) {
          accessoriesList = item.add.map((acc, idx) => ({
            id: idx,
            name: acc.name_add || acc.name,
            quantity: parseInt(acc.amountadd) || parseInt(acc.quantity) || 1,
            price: parseFloat(acc.basePriceadd) || parseFloat(acc.price) || 0
          }));
          itemAccessoriesTotal = accessoriesList.reduce((sum, acc) => sum + (acc.price * acc.quantity), 0);
        } else if (item.accessoriesTotal && item.accessoriesItems && item.accessoriesItems.length > 0) {
          accessoriesList = item.accessoriesItems.map((acc, idx) => ({
            id: idx,
            name: acc.name_add || acc.name,
            quantity: parseInt(acc.amountadd) || parseInt(acc.quantity) || 1,
            price: parseFloat(acc.basePriceadd) || parseFloat(acc.price) || 0
          }));
          itemAccessoriesTotal = item.accessoriesTotal;
        } else if (item.accessoriesTotal && item.add && item.add.length === 0) {
          itemAccessoriesTotal = item.accessoriesTotal;
        }
        
        
        const baseSumInEuro = (displayPrice * quantity) + itemAccessoriesTotal;
        
        
        const convertedBaseSum = convertPrice(baseSumInEuro);
        const convertedDisplayPrice = convertPrice(displayPrice);
        const convertedAccessoriesTotal = convertPrice(itemAccessoriesTotal);
        
        
        const convertedAccessoriesList = accessoriesList.map(acc => ({
          ...acc,
          convertedPrice: convertPrice(acc.price),
          convertedSum: convertPrice(acc.price * acc.quantity)
        }));
        
        return (
          <OrderItemCard
            key={index}
            index={index}
            item={item}
            fabricLabel={fabricLabel}
            displayPrice={displayPrice}
            convertedDisplayPrice={convertedDisplayPrice}
            quantity={quantity}
            accessoriesList={accessoriesList}
            convertedAccessoriesList={convertedAccessoriesList}
            itemAccessoriesTotal={itemAccessoriesTotal}
            convertedAccessoriesTotal={convertedAccessoriesTotal}
            baseSumInEuro={baseSumInEuro}
            convertedBaseSum={convertedBaseSum}
            editingItemIndex={editingItemIndex}
            onEdit={editItem}
            onRemove={removeItem}
            onCopy={copyItem} 
            getCurrencySymbol={getCurrencySymbol}
          />
        );
      })}
    </div>
  )}
</div>

{currentOrder.items.length > 0 && (
  <div className="order-summary">
    <h3>Розрахунок замовлення</h3>
    
    {}
 
    
    {}
    {(() => {
      const marevoDiscountTotal = currentOrder.items.reduce((sum, item) => {
        let discountAmount = 0;
        if (item.priceCalculation?.marevoDiscountAmount) {
          discountAmount += item.priceCalculation.marevoDiscountAmount;
        } else if (item.appliedDiscounts) {
          const marevoDiscount = item.appliedDiscounts.find(d => d.type === 'marevo');
          if (marevoDiscount && marevoDiscount.amount) {
            discountAmount += marevoDiscount.amount;
          }
        }
        return sum + discountAmount;
      }, 0);
      
      return marevoDiscountTotal > 0 ? (
        <div className="summary-row marevo-discount">
          <span>Знижка Марево</span>
          <span>-{convertPrice(marevoDiscountTotal).toFixed(2)} {getCurrencySymbol()}</span>
        </div>
      ) : null;
    })()}
    
    {}
    {(() => {
      const dealerDiscountTotal = currentOrder.items.reduce((sum, item) => {
        let discountAmount = 0;
        if (item.priceCalculation?.dealerDiscountAmount) {
          discountAmount += item.priceCalculation.dealerDiscountAmount;
        } else if (item.appliedDiscounts) {
          const dealerDiscount = item.appliedDiscounts.find(d => d.type === 'dealer');
          if (dealerDiscount && dealerDiscount.amount) {
            discountAmount += dealerDiscount.amount;
          }
        }
        return sum + discountAmount;
      }, 0);
      
      return dealerDiscountTotal > 0 ? (
        <div className="summary-row dealer-discount">
          <span>Знижка дилера</span>
          <span>-{convertPrice(dealerDiscountTotal).toFixed(2)} {getCurrencySymbol()}</span>
        </div>
      ) : null;
    })()}
    
    {}
    {(() => {
      const fabricDiscountTotal = currentOrder.items.reduce((sum, item) => {
        let discountAmount = 0;
        if (item.priceCalculation?.fabricDiscountAmount) {
          discountAmount += item.priceCalculation.fabricDiscountAmount;
        } else if (item.appliedDiscounts) {
          const fabricDiscount = item.appliedDiscounts.find(d => d.type === 'fabric_discount');
          if (fabricDiscount && fabricDiscount.amount) {
            discountAmount += fabricDiscount.amount;
          }
        }
        return sum + discountAmount;
      }, 0);
      
      return fabricDiscountTotal > 0 ? (
        <div className="summary-row fabric-discount">
          <span>Знижка на тканину</span>
          <span>-{convertPrice(fabricDiscountTotal).toFixed(2)} {getCurrencySymbol()}</span>
        </div>
      ) : null;
    })()}
    
    {}
    {(() => {
      const onlineDiscountTotal = currentOrder.items.reduce((sum, item) => {
        let discountAmount = 0;
        if (item.priceCalculation?.onlineDiscountAmount) {
          discountAmount += item.priceCalculation.onlineDiscountAmount;
        } else if (item.appliedDiscounts) {
          const onlineDiscount = item.appliedDiscounts.find(d => d.type === 'online');
          if (onlineDiscount && onlineDiscount.amount) {
            discountAmount += onlineDiscount.amount;
          }
        }
        return sum + discountAmount;
      }, 0);
      
      return (
        <div className="summary-row online-discount">
          <span>Знижка за замовлення онлайн</span>
          <span>-{convertPrice(onlineDiscountTotal).toFixed(2)} {getCurrencySymbol()}</span>
        </div>
      );
    })()}
    
    {}
    <div className="summary-row total">
      <span>Сума зі знижкою</span>
      <span>{(() => {
        const totalBeforeDiscount = currentOrder.items.reduce((sum, item) => {
          if (item.priceCalculation?.totalBeforeDiscount) {
            return sum + item.priceCalculation.totalBeforeDiscount;
          }
          const basePrice = item.basePrice || item.price || 0;
          const quantity = item.quantity || 1;
          let baseSum = basePrice * quantity;
          if (item.add && item.add.length > 0) {
            baseSum += item.add.reduce((accSum, acc) => accSum + (parseFloat(acc.basePriceadd) * parseInt(acc.amountadd)), 0);
          } else if (item.accessoriesTotal) {
            baseSum += item.accessoriesTotal;
          }
          return sum + baseSum;
        }, 0);
        
        const totalDiscount = currentOrder.items.reduce((sum, item) => {
          let discountAmount = 0;
          
          if (item.priceCalculation?.marevoDiscountAmount) {
            discountAmount += item.priceCalculation.marevoDiscountAmount;
          } else if (item.appliedDiscounts) {
            const marevoDiscount = item.appliedDiscounts.find(d => d.type === 'marevo');
            if (marevoDiscount && marevoDiscount.amount) {
              discountAmount += marevoDiscount.amount;
            }
          }
          
          if (item.priceCalculation?.dealerDiscountAmount) {
            discountAmount += item.priceCalculation.dealerDiscountAmount;
          } else if (item.appliedDiscounts) {
            const dealerDiscount = item.appliedDiscounts.find(d => d.type === 'dealer');
            if (dealerDiscount && dealerDiscount.amount) {
              discountAmount += dealerDiscount.amount;
            }
          }
          
          if (item.priceCalculation?.fabricDiscountAmount) {
            discountAmount += item.priceCalculation.fabricDiscountAmount;
          } else if (item.appliedDiscounts) {
            const fabricDiscount = item.appliedDiscounts.find(d => d.type === 'fabric_discount');
            if (fabricDiscount && fabricDiscount.amount) {
              discountAmount += fabricDiscount.amount;
            }
          }
          
          if (item.priceCalculation?.onlineDiscountAmount) {
            discountAmount += item.priceCalculation.onlineDiscountAmount;
          } else if (item.appliedDiscounts) {
            const onlineDiscount = item.appliedDiscounts.find(d => d.type === 'online');
            if (onlineDiscount && onlineDiscount.amount) {
              discountAmount += onlineDiscount.amount;
            }
          }
          
          return sum + discountAmount;
        }, 0);
        
        const finalTotal = totalBeforeDiscount - totalDiscount;
        return convertPrice(finalTotal).toFixed(2);
      })()} {getCurrencySymbol()}</span>
    </div>
  </div>
)}
      <div className="order-disclaimer">
        <p>Обмеження по максимальним висотам та навантаженням на механізм не враховані. Прохання перевіряти допустимі значення в прайс-листі.</p>
        <p>Наявність матеріалів та остаточна ціна підтверджуються менеджером після оформлення замовлення.</p>
        <p>Оплата в гривнях по курсу на день оплати.</p>
      </div>

      <div className="order-notes">
        <h3>Примітки до замовлення</h3>
        <textarea value={currentOrder.notes} onChange={(e) => setCurrentOrder(prev => ({ ...prev, notes: e.target.value }))} placeholder="Додаткові примітки до замовлення..." rows="3" />
      </div>

      <div className="order-confirm-btn">
        <button className="confirm-order-btn" onClick={confirmOrder} disabled={currentOrder.items.length === 0}>Оформити</button>
      </div>
      <div className="order-confirm-btn" style={{ display: 'flex', gap: '10px' }}>

  <button 
    className="save-draft-order-btn" 
    style={{ display: 'flex', gap: '10px' }}
    onClick={saveOrderAsDraft} 
    disabled={currentOrder.items.length === 0 || savingOrderDraft}
    style={{
      marginTop: '5px', 
      flex: 1,
      padding: '12px 20px',
      backgroundColor: '#edec5b',
      color: '#111111',
      border: 'none',
      borderRadius: '6px',
      cursor: currentOrder.items.length === 0 || savingOrderDraft ? 'not-allowed' : 'pointer',
      fontSize: '16px',
      fontWeight: '600',
      transition: 'all 0.2s',
      opacity: currentOrder.items.length === 0 || savingOrderDraft ? 0.6 : 1
    }}
    onMouseEnter={(e) => {
      if (currentOrder.items.length > 0 && !savingOrderDraft) {
        e.target.style.backgroundColor = '#edec5b';
      }
    }}
    onMouseLeave={(e) => {
      if (currentOrder.items.length > 0 && !savingOrderDraft) {
        e.target.style.backgroundColor = '#edec5b';
      }
    }}
  >
    {savingOrderDraft ? 'Збереження...' : 'Зберегти як чернетку'}
  </button>
</div>
    </div>
  </div>
</div>
    </div>
  );
}

const ConfirmDialog = ({ isOpen, message, onConfirm, onCancel }) => {
  if (!isOpen) return null;
  const lines = message.split('\n');
  return (
    <div className="confirm-dialog-overlay">
      <div className="confirm-dialog">
        <div className="confirm-dialog-message">
          {lines.map((line, index) => {
            if (line.trim() === '') return <br key={index} />;
            const colonIndex = line.indexOf(':');
            if (colonIndex > 0) {
              const label = line.substring(0, colonIndex + 1);
              const value = line.substring(colonIndex + 1);
              return (<div key={index} className="confirm-dialog-line"><span className="confirm-label">{label}</span><span className="confirm-value">{value}</span></div>);
            }
            return <div key={index} className="confirm-dialog-line full-width">{line}</div>;
          })}
        </div>
        <div className="confirm-dialog-buttons">
          <button onClick={onConfirm} className="confirm-btn">Так</button>
          <button onClick={onCancel} className="cancel-btn">Ні</button>
        </div>
      </div>
    </div>
  );
};

export default OrderPage;
